(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/libs/oddsmind-chat-component/assets/javascripts/oddsmind-chat.js') >= 0) return;  svs.modules.push('/components/libs/oddsmind-chat-component/assets/javascripts/oddsmind-chat.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function () {
  "use strict";

  if (customElements.get("oddsmind-chat")) return;
  const DEFAULT_API_BASE = "https://demo.oddsmind.ai";

  const DOMPurify = function () {
    const _prev = window.DOMPurify;
    const _prevDefine = window.define;
    if (_prevDefine && _prevDefine.amd) {
      try {
        window.define = undefined;
      } catch (_) {}
    }
    !function (e, t) {
      "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = "undefined" != typeof globalThis ? globalThis : e || self).DOMPurify = t();
    }(this, function () {
      "use strict";

      function e(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, o = Array(t); n < t; n++) o[n] = e[n];
        return o;
      }
      function t(t, n) {
        return function (e) {
          if (Array.isArray(e)) return e;
        }(t) || function (e, t) {
          var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
          if (null != n) {
            var o,
              r,
              i,
              a,
              l = [],
              c = !0,
              s = !1;
            try {
              if (i = (n = n.call(e)).next, 0 === t) ;else for (; !(c = (o = i.call(n)).done) && (l.push(o.value), l.length !== t); c = !0);
            } catch (e) {
              s = !0, r = e;
            } finally {
              try {
                if (!c && null != n.return && (a = n.return(), Object(a) !== a)) return;
              } finally {
                if (s) throw r;
              }
            }
            return l;
          }
        }(t, n) || function (t, n) {
          if (t) {
            if ("string" == typeof t) return e(t, n);
            var o = {}.toString.call(t).slice(8, -1);
            return "Object" === o && t.constructor && (o = t.constructor.name), "Map" === o || "Set" === o ? Array.from(t) : "Arguments" === o || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? e(t, n) : void 0;
          }
        }(t, n) || function () {
          throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
      }
      const n = Object.entries,
        o = Object.setPrototypeOf,
        r = Object.isFrozen,
        i = Object.getPrototypeOf,
        a = Object.getOwnPropertyDescriptor;
      let l = Object.freeze,
        c = Object.seal,
        s = Object.create,
        u = "undefined" != typeof Reflect && Reflect,
        f = u.apply,
        m = u.construct;
      l || (l = function (e) {
        return e;
      }), c || (c = function (e) {
        return e;
      }), f || (f = function (e, t) {
        for (var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++) o[r - 2] = arguments[r];
        return e.apply(t, o);
      }), m || (m = function (e) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++) n[o - 1] = arguments[o];
        return new e(...n);
      });
      const p = L(Array.prototype.forEach),
        d = L(Array.prototype.lastIndexOf),
        h = L(Array.prototype.pop),
        g = L(Array.prototype.push),
        y = L(Array.prototype.splice),
        T = Array.isArray,
        b = L(String.prototype.toLowerCase),
        A = L(String.prototype.toString),
        S = L(String.prototype.match),
        E = L(String.prototype.replace),
        N = L(String.prototype.indexOf),
        _ = L(String.prototype.trim),
        O = L(Number.prototype.toString),
        D = L(Boolean.prototype.toString),
        R = "undefined" == typeof BigInt ? null : L(BigInt.prototype.toString),
        w = "undefined" == typeof Symbol ? null : L(Symbol.prototype.toString),
        I = L(Object.prototype.hasOwnProperty),
        v = L(Object.prototype.toString),
        C = L(RegExp.prototype.test),
        x = (k = TypeError, function () {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
          return m(k, t);
        });
      var k;
      function L(e) {
        return function (t) {
          t instanceof RegExp && (t.lastIndex = 0);
          for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++) o[r - 1] = arguments[r];
          return f(e, t, o);
        };
      }
      function M(e, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : b;
        if (o && o(e, null), !T(t)) return e;
        let i = t.length;
        for (; i--;) {
          let o = t[i];
          if ("string" == typeof o) {
            const e = n(o);
            e !== o && (r(t) || (t[i] = e), o = e);
          }
          e[o] = !0;
        }
        return e;
      }
      function z(e) {
        for (let t = 0; t < e.length; t++) {
          I(e, t) || (e[t] = null);
        }
        return e;
      }
      function F(e) {
        const o = s(null);
        for (const i of n(e)) {
          var r = t(i, 2);
          const n = r[0],
            a = r[1];
          I(e, n) && (T(a) ? o[n] = z(a) : a && "object" == typeof a && a.constructor === Object ? o[n] = F(a) : o[n] = a);
        }
        return o;
      }
      function P(e, t) {
        for (; null !== e;) {
          const n = a(e, t);
          if (n) {
            if (n.get) return L(n.get);
            if ("function" == typeof n.value) return L(n.value);
          }
          e = i(e);
        }
        return function () {
          return null;
        };
      }
      const U = l(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
        H = l(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
        B = l(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
        j = l(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
        G = l(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
        W = l(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
        Y = l(["#text"]),
        X = l(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]),
        q = l(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
        $ = l(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
        K = l(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
        V = c(/{{[\w\W]*|^[\w\W]*}}/g),
        Z = c(/<%[\w\W]*|^[\w\W]*%>/g),
        J = c(/\${[\w\W]*/g),
        Q = c(/^data-[\-\w.\u00B7-\uFFFF]+$/),
        ee = c(/^aria-[\-\w]+$/),
        te = c(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
        ne = c(/^(?:\w+script|data):/i),
        oe = c(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
        re = c(/^html$/i),
        ie = c(/^[a-z][.\w]*(-[.\w]+)+$/i),
        ae = 1,
        le = 3,
        ce = 7,
        se = 8,
        ue = 9,
        fe = 11,
        me = function () {
          return "undefined" == typeof window ? null : window;
        };
      var pe = function e() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : me();
        const o = t => e(t);
        if (o.version = "3.4.7", o.removed = [], !t || !t.document || t.document.nodeType !== ue || !t.Element) return o.isSupported = !1, o;
        let r = t.document;
        const i = r,
          a = i.currentScript;
        t.DocumentFragment;
        const c = t.HTMLTemplateElement,
          u = t.Node,
          f = t.Element,
          m = t.NodeFilter,
          k = t.NamedNodeMap;
        void 0 === k && (t.NamedNodeMap || t.MozNamedAttrMap), t.HTMLFormElement;
        const L = t.DOMParser,
          z = t.trustedTypes,
          pe = f.prototype,
          de = P(pe, "cloneNode"),
          he = P(pe, "remove"),
          ge = P(pe, "nextSibling"),
          ye = P(pe, "childNodes"),
          Te = P(pe, "parentNode"),
          be = P(pe, "shadowRoot"),
          Ae = P(pe, "attributes"),
          Se = u && u.prototype ? P(u.prototype, "nodeType") : null,
          Ee = u && u.prototype ? P(u.prototype, "nodeName") : null;
        if ("function" == typeof c) {
          const e = r.createElement("template");
          e.content && e.content.ownerDocument && (r = e.content.ownerDocument);
        }
        let Ne,
          _e = "";
        const Oe = r,
          De = Oe.implementation,
          Re = Oe.createNodeIterator,
          we = Oe.createDocumentFragment,
          Ie = Oe.getElementsByTagName,
          ve = i.importNode;
        let Ce = {
          afterSanitizeAttributes: [],
          afterSanitizeElements: [],
          afterSanitizeShadowDOM: [],
          beforeSanitizeAttributes: [],
          beforeSanitizeElements: [],
          beforeSanitizeShadowDOM: [],
          uponSanitizeAttribute: [],
          uponSanitizeElement: [],
          uponSanitizeShadowNode: []
        };
        o.isSupported = "function" == typeof n && "function" == typeof Te && De && void 0 !== De.createHTMLDocument;
        const xe = V,
          ke = Z,
          Le = J,
          Me = Q,
          ze = ee,
          Fe = ne,
          Pe = oe,
          Ue = ie;
        let He = te,
          Be = null;
        const je = M({}, [...U, ...H, ...B, ...G, ...Y]);
        let Ge = null;
        const We = M({}, [...X, ...q, ...$, ...K]);
        let Ye = Object.seal(s(null, {
            tagNameCheck: {
              writable: !0,
              configurable: !1,
              enumerable: !0,
              value: null
            },
            attributeNameCheck: {
              writable: !0,
              configurable: !1,
              enumerable: !0,
              value: null
            },
            allowCustomizedBuiltInElements: {
              writable: !0,
              configurable: !1,
              enumerable: !0,
              value: !1
            }
          })),
          Xe = null,
          qe = null;
        const $e = Object.seal(s(null, {
          tagCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          },
          attributeCheck: {
            writable: !0,
            configurable: !1,
            enumerable: !0,
            value: null
          }
        }));
        let Ke = !0,
          Ve = !0,
          Ze = !1,
          Je = !0,
          Qe = !1,
          et = !0,
          tt = !1,
          nt = !1,
          ot = !1,
          rt = !1,
          it = !1,
          at = !1,
          lt = !0,
          ct = !1;
        const st = "user-content-";
        let ut = !0,
          ft = !1,
          mt = {},
          pt = null;
        const dt = M({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
        let ht = null;
        const gt = M({}, ["audio", "video", "img", "source", "image", "track"]);
        let yt = null;
        const Tt = M({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
          bt = "http://www.w3.org/1998/Math/MathML",
          At = "http://www.w3.org/2000/svg",
          St = "http://www.w3.org/1999/xhtml";
        let Et = St,
          Nt = !1,
          _t = null;
        const Ot = M({}, [bt, At, St], A);
        let Dt = M({}, ["mi", "mo", "mn", "ms", "mtext"]),
          Rt = M({}, ["annotation-xml"]);
        const wt = M({}, ["title", "style", "font", "a", "script"]);
        let It = null;
        const vt = ["application/xhtml+xml", "text/html"];
        let Ct = null,
          xt = null;
        const kt = r.createElement("form"),
          Lt = function (e) {
            return e instanceof RegExp || e instanceof Function;
          },
          Mt = function () {
            let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (xt && xt === e) return;
            e && "object" == typeof e || (e = {}), e = F(e), It = -1 === vt.indexOf(e.PARSER_MEDIA_TYPE) ? "text/html" : e.PARSER_MEDIA_TYPE, Ct = "application/xhtml+xml" === It ? A : b, Be = I(e, "ALLOWED_TAGS") && T(e.ALLOWED_TAGS) ? M({}, e.ALLOWED_TAGS, Ct) : je, Ge = I(e, "ALLOWED_ATTR") && T(e.ALLOWED_ATTR) ? M({}, e.ALLOWED_ATTR, Ct) : We, _t = I(e, "ALLOWED_NAMESPACES") && T(e.ALLOWED_NAMESPACES) ? M({}, e.ALLOWED_NAMESPACES, A) : Ot, yt = I(e, "ADD_URI_SAFE_ATTR") && T(e.ADD_URI_SAFE_ATTR) ? M(F(Tt), e.ADD_URI_SAFE_ATTR, Ct) : Tt, ht = I(e, "ADD_DATA_URI_TAGS") && T(e.ADD_DATA_URI_TAGS) ? M(F(gt), e.ADD_DATA_URI_TAGS, Ct) : gt, pt = I(e, "FORBID_CONTENTS") && T(e.FORBID_CONTENTS) ? M({}, e.FORBID_CONTENTS, Ct) : dt, Xe = I(e, "FORBID_TAGS") && T(e.FORBID_TAGS) ? M({}, e.FORBID_TAGS, Ct) : F({}), qe = I(e, "FORBID_ATTR") && T(e.FORBID_ATTR) ? M({}, e.FORBID_ATTR, Ct) : F({}), mt = !!I(e, "USE_PROFILES") && (e.USE_PROFILES && "object" == typeof e.USE_PROFILES ? F(e.USE_PROFILES) : e.USE_PROFILES), Ke = !1 !== e.ALLOW_ARIA_ATTR, Ve = !1 !== e.ALLOW_DATA_ATTR, Ze = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Je = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, Qe = e.SAFE_FOR_TEMPLATES || !1, et = !1 !== e.SAFE_FOR_XML, tt = e.WHOLE_DOCUMENT || !1, rt = e.RETURN_DOM || !1, it = e.RETURN_DOM_FRAGMENT || !1, at = e.RETURN_TRUSTED_TYPE || !1, ot = e.FORCE_BODY || !1, lt = !1 !== e.SANITIZE_DOM, ct = e.SANITIZE_NAMED_PROPS || !1, ut = !1 !== e.KEEP_CONTENT, ft = e.IN_PLACE || !1, He = function (e) {
              try {
                return C(e, ""), !0;
              } catch (e) {
                return !1;
              }
            }(e.ALLOWED_URI_REGEXP) ? e.ALLOWED_URI_REGEXP : te, Et = "string" == typeof e.NAMESPACE ? e.NAMESPACE : St, Dt = I(e, "MATHML_TEXT_INTEGRATION_POINTS") && e.MATHML_TEXT_INTEGRATION_POINTS && "object" == typeof e.MATHML_TEXT_INTEGRATION_POINTS ? F(e.MATHML_TEXT_INTEGRATION_POINTS) : M({}, ["mi", "mo", "mn", "ms", "mtext"]), Rt = I(e, "HTML_INTEGRATION_POINTS") && e.HTML_INTEGRATION_POINTS && "object" == typeof e.HTML_INTEGRATION_POINTS ? F(e.HTML_INTEGRATION_POINTS) : M({}, ["annotation-xml"]);
            const t = I(e, "CUSTOM_ELEMENT_HANDLING") && e.CUSTOM_ELEMENT_HANDLING && "object" == typeof e.CUSTOM_ELEMENT_HANDLING ? F(e.CUSTOM_ELEMENT_HANDLING) : s(null);
            if (Ye = s(null), I(t, "tagNameCheck") && Lt(t.tagNameCheck) && (Ye.tagNameCheck = t.tagNameCheck), I(t, "attributeNameCheck") && Lt(t.attributeNameCheck) && (Ye.attributeNameCheck = t.attributeNameCheck), I(t, "allowCustomizedBuiltInElements") && "boolean" == typeof t.allowCustomizedBuiltInElements && (Ye.allowCustomizedBuiltInElements = t.allowCustomizedBuiltInElements), Qe && (Ve = !1), it && (rt = !0), mt && (Be = M({}, Y), Ge = s(null), !0 === mt.html && (M(Be, U), M(Ge, X)), !0 === mt.svg && (M(Be, H), M(Ge, q), M(Ge, K)), !0 === mt.svgFilters && (M(Be, B), M(Ge, q), M(Ge, K)), !0 === mt.mathMl && (M(Be, G), M(Ge, $), M(Ge, K))), $e.tagCheck = null, $e.attributeCheck = null, I(e, "ADD_TAGS") && ("function" == typeof e.ADD_TAGS ? $e.tagCheck = e.ADD_TAGS : T(e.ADD_TAGS) && (Be === je && (Be = F(Be)), M(Be, e.ADD_TAGS, Ct))), I(e, "ADD_ATTR") && ("function" == typeof e.ADD_ATTR ? $e.attributeCheck = e.ADD_ATTR : T(e.ADD_ATTR) && (Ge === We && (Ge = F(Ge)), M(Ge, e.ADD_ATTR, Ct))), I(e, "ADD_URI_SAFE_ATTR") && T(e.ADD_URI_SAFE_ATTR) && M(yt, e.ADD_URI_SAFE_ATTR, Ct), I(e, "FORBID_CONTENTS") && T(e.FORBID_CONTENTS) && (pt === dt && (pt = F(pt)), M(pt, e.FORBID_CONTENTS, Ct)), I(e, "ADD_FORBID_CONTENTS") && T(e.ADD_FORBID_CONTENTS) && (pt === dt && (pt = F(pt)), M(pt, e.ADD_FORBID_CONTENTS, Ct)), ut && (Be["#text"] = !0), tt && M(Be, ["html", "head", "body"]), Be.table && (M(Be, ["tbody"]), delete Xe.tbody), e.TRUSTED_TYPES_POLICY) {
              if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
              if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
              Ne = e.TRUSTED_TYPES_POLICY, _e = Ne.createHTML("");
            } else void 0 === Ne && (Ne = function (e, t) {
              if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
              let n = null;
              const o = "data-tt-policy-suffix";
              t && t.hasAttribute(o) && (n = t.getAttribute(o));
              const r = "dompurify" + (n ? "#" + n : "");
              try {
                return e.createPolicy(r, {
                  createHTML: e => e,
                  createScriptURL: e => e
                });
              } catch (e) {
                return console.warn("TrustedTypes policy " + r + " could not be created."), null;
              }
            }(z, a)), null !== Ne && "string" == typeof _e && (_e = Ne.createHTML(""));
            (Ce.uponSanitizeElement.length > 0 || Ce.uponSanitizeAttribute.length > 0) && Be === je && (Be = F(Be)), Ce.uponSanitizeAttribute.length > 0 && Ge === We && (Ge = F(Ge)), l && l(e), xt = e;
          },
          zt = M({}, [...H, ...B, ...j]),
          Ft = M({}, [...G, ...W]),
          Pt = function (e) {
            g(o.removed, {
              element: e
            });
            try {
              Te(e).removeChild(e);
            } catch (t) {
              he(e);
            }
          },
          Ut = function (e, t) {
            try {
              g(o.removed, {
                attribute: t.getAttributeNode(e),
                from: t
              });
            } catch (e) {
              g(o.removed, {
                attribute: null,
                from: t
              });
            }
            if (t.removeAttribute(e), "is" === e) if (rt || it) try {
              Pt(t);
            } catch (e) {} else try {
              t.setAttribute(e, "");
            } catch (e) {}
          },
          Ht = function (e) {
            let t = null,
              n = null;
            if (ot) e = "<remove></remove>" + e;else {
              const t = S(e, /^[\r\n\t ]+/);
              n = t && t[0];
            }
            "application/xhtml+xml" === It && Et === St && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
            const o = Ne ? Ne.createHTML(e) : e;
            if (Et === St) try {
              t = new L().parseFromString(o, It);
            } catch (e) {}
            if (!t || !t.documentElement) {
              t = De.createDocument(Et, "template", null);
              try {
                t.documentElement.innerHTML = Nt ? _e : o;
              } catch (e) {}
            }
            const i = t.body || t.documentElement;
            return e && n && i.insertBefore(r.createTextNode(n), i.childNodes[0] || null), Et === St ? Ie.call(t, tt ? "html" : "body")[0] : tt ? t.documentElement : i;
          },
          Bt = function (e) {
            return Re.call(e.ownerDocument || e, e, m.SHOW_ELEMENT | m.SHOW_COMMENT | m.SHOW_TEXT | m.SHOW_PROCESSING_INSTRUCTION | m.SHOW_CDATA_SECTION, null);
          },
          jt = function (e) {
            e.normalize();
            const t = Re.call(e.ownerDocument || e, e, m.SHOW_TEXT | m.SHOW_COMMENT | m.SHOW_CDATA_SECTION | m.SHOW_PROCESSING_INSTRUCTION, null);
            let n = t.nextNode();
            for (; n;) {
              let e = n.data;
              p([xe, ke, Le], t => {
                e = E(e, t, " ");
              }), n.data = e, n = t.nextNode();
            }
          },
          Gt = function (e) {
            const t = Ee ? Ee(e) : null;
            return "string" == typeof t && "form" === Ct(t) && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || e.attributes !== Ae(e) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes || e.nodeType !== Se(e) || e.childNodes !== ye(e));
          },
          Wt = function (e) {
            if (!Se || "object" != typeof e || null === e) return !1;
            try {
              return Se(e) === fe;
            } catch (e) {
              return !1;
            }
          },
          Yt = function (e) {
            if (!Se || "object" != typeof e || null === e) return !1;
            try {
              return "number" == typeof Se(e);
            } catch (e) {
              return !1;
            }
          };
        function Xt(e, t, n) {
          p(e, e => {
            e.call(o, t, n, xt);
          });
        }
        const qt = function (e) {
            let t = null;
            if (Xt(Ce.beforeSanitizeElements, e, null), Gt(e)) return Pt(e), !0;
            const n = Ct(e.nodeName);
            if (Xt(Ce.uponSanitizeElement, e, {
              tagName: n,
              allowedTags: Be
            }), et && e.hasChildNodes() && !Yt(e.firstElementChild) && C(/<[/\w!]/g, e.innerHTML) && C(/<[/\w!]/g, e.textContent)) return Pt(e), !0;
            if (et && e.namespaceURI === St && "style" === n && Yt(e.firstElementChild)) return Pt(e), !0;
            if (e.nodeType === ce) return Pt(e), !0;
            if (et && e.nodeType === se && C(/<[/\w]/g, e.data)) return Pt(e), !0;
            if (Xe[n] || !($e.tagCheck instanceof Function && $e.tagCheck(n)) && !Be[n]) {
              if (!Xe[n] && Vt(n)) {
                if (Ye.tagNameCheck instanceof RegExp && C(Ye.tagNameCheck, n)) return !1;
                if (Ye.tagNameCheck instanceof Function && Ye.tagNameCheck(n)) return !1;
              }
              if (ut && !pt[n]) {
                const t = Te(e),
                  n = ye(e);
                if (n && t) {
                  for (let o = n.length - 1; o >= 0; --o) {
                    const r = de(n[o], !0);
                    t.insertBefore(r, ge(e));
                  }
                }
              }
              return Pt(e), !0;
            }
            return ((Se ? Se(e) : e.nodeType) !== ae || function (e) {
              let t = Te(e);
              t && t.tagName || (t = {
                namespaceURI: Et,
                tagName: "template"
              });
              const n = b(e.tagName),
                o = b(t.tagName);
              return !!_t[e.namespaceURI] && (e.namespaceURI === At ? t.namespaceURI === St ? "svg" === n : t.namespaceURI === bt ? "svg" === n && ("annotation-xml" === o || Dt[o]) : Boolean(zt[n]) : e.namespaceURI === bt ? t.namespaceURI === St ? "math" === n : t.namespaceURI === At ? "math" === n && Rt[o] : Boolean(Ft[n]) : e.namespaceURI === St ? !(t.namespaceURI === At && !Rt[o]) && !(t.namespaceURI === bt && !Dt[o]) && !Ft[n] && (wt[n] || !zt[n]) : !("application/xhtml+xml" !== It || !_t[e.namespaceURI]));
            }(e)) && ("noscript" !== n && "noembed" !== n && "noframes" !== n || !C(/<\/no(script|embed|frames)/i, e.innerHTML)) ? (Qe && e.nodeType === le && (t = e.textContent, p([xe, ke, Le], e => {
              t = E(t, e, " ");
            }), e.textContent !== t && (g(o.removed, {
              element: e.cloneNode()
            }), e.textContent = t)), Xt(Ce.afterSanitizeElements, e, null), !1) : (Pt(e), !0);
          },
          $t = function (e, t, n) {
            if (qe[t]) return !1;
            if (lt && ("id" === t || "name" === t) && (n in r || n in kt)) return !1;
            const o = Ge[t] || $e.attributeCheck instanceof Function && $e.attributeCheck(t, e);
            if (Ve && !qe[t] && C(Me, t)) ;else if (Ke && C(ze, t)) ;else if (!o || qe[t]) {
              if (!(Vt(e) && (Ye.tagNameCheck instanceof RegExp && C(Ye.tagNameCheck, e) || Ye.tagNameCheck instanceof Function && Ye.tagNameCheck(e)) && (Ye.attributeNameCheck instanceof RegExp && C(Ye.attributeNameCheck, t) || Ye.attributeNameCheck instanceof Function && Ye.attributeNameCheck(t, e)) || "is" === t && Ye.allowCustomizedBuiltInElements && (Ye.tagNameCheck instanceof RegExp && C(Ye.tagNameCheck, n) || Ye.tagNameCheck instanceof Function && Ye.tagNameCheck(n)))) return !1;
            } else if (yt[t]) ;else if (C(He, E(n, Pe, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== N(n, "data:") || !ht[e]) {
              if (Ze && !C(Fe, E(n, Pe, ""))) ;else if (n) return !1;
            } else ;
            return !0;
          },
          Kt = M({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]),
          Vt = function (e) {
            return !Kt[b(e)] && C(Ue, e);
          },
          Zt = function (e) {
            Xt(Ce.beforeSanitizeAttributes, e, null);
            const t = e.attributes;
            if (!t || Gt(e)) return;
            const n = {
              attrName: "",
              attrValue: "",
              keepAttr: !0,
              allowedAttributes: Ge,
              forceKeepAttr: void 0
            };
            let r = t.length;
            for (; r--;) {
              const i = t[r],
                a = i.name,
                l = i.namespaceURI,
                c = i.value,
                s = Ct(a),
                u = c;
              let f = "value" === a ? u : _(u);
              if (n.attrName = s, n.attrValue = f, n.keepAttr = !0, n.forceKeepAttr = void 0, Xt(Ce.uponSanitizeAttribute, e, n), f = n.attrValue, !ct || "id" !== s && "name" !== s || 0 === N(f, st) || (Ut(a, e), f = st + f), et && C(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, f)) {
                Ut(a, e);
                continue;
              }
              if ("attributename" === s && S(f, "href")) {
                Ut(a, e);
                continue;
              }
              if (n.forceKeepAttr) continue;
              if (!n.keepAttr) {
                Ut(a, e);
                continue;
              }
              if (!Je && C(/\/>/i, f)) {
                Ut(a, e);
                continue;
              }
              Qe && p([xe, ke, Le], e => {
                f = E(f, e, " ");
              });
              const m = Ct(e.nodeName);
              if ($t(m, s, f)) {
                if (Ne && "object" == typeof z && "function" == typeof z.getAttributeType) if (l) ;else switch (z.getAttributeType(m, s)) {
                  case "TrustedHTML":
                    f = Ne.createHTML(f);
                    break;
                  case "TrustedScriptURL":
                    f = Ne.createScriptURL(f);
                }
                if (f !== u) try {
                  l ? e.setAttributeNS(l, a, f) : e.setAttribute(a, f), Gt(e) ? Pt(e) : h(o.removed);
                } catch (t) {
                  Ut(a, e);
                }
              } else Ut(a, e);
            }
            Xt(Ce.afterSanitizeAttributes, e, null);
          },
          Jt = function (e) {
            let t = null;
            const n = Bt(e);
            for (Xt(Ce.beforeSanitizeShadowDOM, e, null); t = n.nextNode();) {
              Xt(Ce.uponSanitizeShadowNode, t, null), qt(t), Zt(t), Wt(t.content) && Jt(t.content);
              if ((Se ? Se(t) : t.nodeType) === ae) {
                const e = be ? be(t) : t.shadowRoot;
                Wt(e) && (Qt(e), Jt(e));
              }
            }
            Xt(Ce.afterSanitizeShadowDOM, e, null);
          },
          Qt = function (e) {
            const t = Se ? Se(e) : e.nodeType;
            if (t === ae) {
              const t = be ? be(e) : e.shadowRoot;
              Wt(t) && (Qt(t), Jt(t));
            }
            const n = ye ? ye(e) : e.childNodes;
            if (!n) return;
            const o = [];
            p(n, e => {
              g(o, e);
            });
            for (const e of o) Qt(e);
            if (t === ae) {
              const t = Ee ? Ee(e) : null;
              if ("string" == typeof t && "template" === Ct(t)) {
                const t = e.content;
                Wt(t) && Qt(t);
              }
            }
          };
        return o.sanitize = function (e) {
          let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = null,
            r = null,
            a = null,
            l = null;
          if (Nt = !e, Nt && (e = "\x3c!--\x3e"), "string" != typeof e && !Yt(e) && "string" != typeof (e = function (e) {
            switch (typeof e) {
              case "string":
                return e;
              case "number":
                return O(e);
              case "boolean":
                return D(e);
              case "bigint":
                return R ? R(e) : "0";
              case "symbol":
                return w ? w(e) : "Symbol()";
              case "undefined":
              default:
                return v(e);
              case "function":
              case "object":
                {
                  if (null === e) return v(e);
                  const t = e,
                    n = P(t, "toString");
                  if ("function" == typeof n) {
                    const e = n(t);
                    return "string" == typeof e ? e : v(e);
                  }
                  return v(e);
                }
            }
          }(e))) throw x("dirty is not a string, aborting");
          if (!o.isSupported) return e;
          if (nt || Mt(t), o.removed = [], "string" == typeof e && (ft = !1), ft) {
            const t = Ee ? Ee(e) : e.nodeName;
            if ("string" == typeof t) {
              const e = Ct(t);
              if (!Be[e] || Xe[e]) throw x("root node is forbidden and cannot be sanitized in-place");
            }
            if (Gt(e)) throw x("root node is clobbered and cannot be sanitized in-place");
            Qt(e);
          } else if (Yt(e)) n = Ht("\x3c!----\x3e"), r = n.ownerDocument.importNode(e, !0), r.nodeType === ae && "BODY" === r.nodeName || "HTML" === r.nodeName ? n = r : n.appendChild(r), Qt(r);else {
            if (!rt && !Qe && !tt && -1 === e.indexOf("<")) return Ne && at ? Ne.createHTML(e) : e;
            if (n = Ht(e), !n) return rt ? null : at ? _e : "";
          }
          n && ot && Pt(n.firstChild);
          const c = Bt(ft ? e : n);
          for (; a = c.nextNode();) qt(a), Zt(a), Wt(a.content) && Jt(a.content);
          if (ft) return Qe && jt(e), e;
          if (rt) {
            if (Qe && jt(n), it) for (l = we.call(n.ownerDocument); n.firstChild;) l.appendChild(n.firstChild);else l = n;
            return (Ge.shadowroot || Ge.shadowrootmode) && (l = ve.call(i, l, !0)), l;
          }
          let s = tt ? n.outerHTML : n.innerHTML;
          return tt && Be["!doctype"] && n.ownerDocument && n.ownerDocument.doctype && n.ownerDocument.doctype.name && C(re, n.ownerDocument.doctype.name) && (s = "<!DOCTYPE " + n.ownerDocument.doctype.name + ">\n" + s), Qe && p([xe, ke, Le], e => {
            s = E(s, e, " ");
          }), Ne && at ? Ne.createHTML(s) : s;
        }, o.setConfig = function () {
          Mt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), nt = !0;
        }, o.clearConfig = function () {
          xt = null, nt = !1;
        }, o.isValidAttribute = function (e, t, n) {
          xt || Mt({});
          const o = Ct(e),
            r = Ct(t);
          return $t(o, r, n);
        }, o.addHook = function (e, t) {
          "function" == typeof t && g(Ce[e], t);
        }, o.removeHook = function (e, t) {
          if (void 0 !== t) {
            const n = d(Ce[e], t);
            return -1 === n ? void 0 : y(Ce[e], n, 1)[0];
          }
          return h(Ce[e]);
        }, o.removeHooks = function (e) {
          Ce[e] = [];
        }, o.removeAllHooks = function () {
          Ce = {
            afterSanitizeAttributes: [],
            afterSanitizeElements: [],
            afterSanitizeShadowDOM: [],
            beforeSanitizeAttributes: [],
            beforeSanitizeElements: [],
            beforeSanitizeShadowDOM: [],
            uponSanitizeAttribute: [],
            uponSanitizeElement: [],
            uponSanitizeShadowNode: []
          };
        }, o;
      }();
      return pe;
    });
    const _captured = window.DOMPurify;
    if (_prev === undefined) {
      try {
        delete window.DOMPurify;
      } catch (_) {
        window.DOMPurify = undefined;
      }
    } else {
      window.DOMPurify = _prev;
    }
    if (_prevDefine !== undefined) window.define = _prevDefine;
    return _captured;
  }();

  const SANITIZE_CONFIG = {
    ALLOWED_TAGS: ["p", "br", "strong", "em", "b", "i", "u", "ul", "ol", "li", "table", "thead", "tbody", "tr", "th", "td", "div", "span", "h1", "h2", "h3", "h4", "h5", "h6", "a", "code", "pre", "img"],
    ALLOWED_ATTR: ["class", "style", "href", "target", "rel", "align", "src", "alt", "title"],
    FORBID_ATTR: ["onclick", "onerror", "onload", "onmouseover", "onmouseout", "onfocus", "onblur", "onsubmit", "onchange"]
  };

  const CONV_PERSIST_VERSION = 1;
  const CONV_PERSIST_TTL_MS = 60 * 60 * 1000; 
  const CONV_PERSIST_MAX_MSGS = 50; 

  const THINKING_MESSAGES = {
    en: ["Scanning the pitch\u2026", "Checking the form table\u2026", "Reviewing match stats\u2026", "Analysing xG data\u2026", "Crunching the odds\u2026", "Scouting the lineups\u2026", "Studying head-to-head records\u2026", "Reading the injury report\u2026", "Consulting the VAR room\u2026", "Warming up the analysis engine\u2026", "Evaluating recent performances\u2026", "Comparing league standings\u2026", "Watching the pre-match warm-up\u2026", "Calculating value bets\u2026", "Checking squad rotation\u2026", "Reviewing tactical setups\u2026", "Loading transfer deadline intel\u2026", "Parsing corner & card stats\u2026", "Finding the best odds\u2026", "Mapping out goal-scoring patterns\u2026"],
    sv: ["Spanar in planen\u2026", "Kollar formtabellen\u2026", "Granskar matchstatistiken\u2026", "Analyserar xG-data\u2026", "R\u00e4knar p\u00e5 oddsen\u2026", "Scoutar startelvorna\u2026", "Studerar inb\u00f6rdes m\u00f6ten\u2026", "L\u00e4ser skaderapporten\u2026", "R\u00e5dfr\u00e5gar VAR-rummet\u2026", "V\u00e4rmer upp analysmotorn\u2026", "Utv\u00e4rderar de senaste insatserna\u2026", "J\u00e4mf\u00f6r tabell\u00e4get\u2026", "Tittar p\u00e5 uppv\u00e4rmningen\u2026", "Ber\u00e4knar value-spel\u2026", "Kollar rotationen i truppen\u2026", "Granskar de taktiska uppl\u00e4ggen\u2026", "H\u00e4mtar transfernyheter\u2026", "G\u00e5r igenom h\u00f6rn- och kortstatistik\u2026", "Letar upp b\u00e4sta oddsen\u2026", "Kartl\u00e4gger m\u00e5lm\u00f6nster\u2026"],
    de: ["Scanne den Platz\u2026", "Pr\u00fcfe die Formtabelle\u2026", "Sichte die Spielstatistik\u2026", "Analysiere die xG-Daten\u2026", "Rechne die Quoten durch\u2026", "Scoute die Aufstellungen\u2026", "Studiere die direkten Duelle\u2026", "Lese den Verletzungsbericht\u2026", "Frage den VAR-Raum\u2026", "W\u00e4rme die Analyse-Engine auf\u2026", "Werte die letzten Leistungen aus\u2026", "Vergleiche die Tabelle\u2026", "Schaue beim Aufw\u00e4rmen zu\u2026", "Berechne Value-Wetten\u2026", "Pr\u00fcfe die Rotation\u2026", "Sichte die taktischen Aufstellungen\u2026", "Lade Transfer-Infos\u2026", "Werte Ecken- & Kartenstatistik aus\u2026", "Finde die besten Quoten\u2026", "Kartiere die Tormuster\u2026"],
    pt: ["Examinando o campo\u2026", "Conferindo a tabela de forma\u2026", "Revisando as estat\u00edsticas do jogo\u2026", "Analisando os dados de xG\u2026", "Calculando as odds\u2026", "Avaliando as escala\u00e7\u00f5es\u2026", "Estudando os confrontos diretos\u2026", "Lendo o boletim de les\u00f5es\u2026", "Consultando a sala do VAR\u2026", "Aquecendo o motor de an\u00e1lise\u2026", "Avaliando as atua\u00e7\u00f5es recentes\u2026", "Comparando a classifica\u00e7\u00e3o\u2026", "Assistindo ao aquecimento\u2026", "Calculando apostas de valor\u2026", "Conferindo o rod\u00edzio do elenco\u2026", "Revisando os esquemas t\u00e1ticos\u2026", "Carregando not\u00edcias de transfer\u00eancias\u2026", "Analisando escanteios e cart\u00f5es\u2026", "Buscando as melhores odds\u2026", "Mapeando os padr\u00f5es de gols\u2026"]
  };

  const UI_TEXT = {
    en: {
      ask: "Ask about any match, team, or bet\u2026",
      waiting: "Waiting for response\u2026",
      genericError: "Something went wrong. Please try again.",
      missingKey: "Error: missing widget-key attribute.",
      open: "Open",
      hide: "Hide assistant"
    },
    sv: {
      ask: "Fr\u00e5ga om vilken match, lag eller spel som helst\u2026",
      waiting: "V\u00e4ntar p\u00e5 svar\u2026",
      genericError: "N\u00e5got gick fel. F\u00f6rs\u00f6k igen.",
      missingKey: "Fel: attributet widget-key saknas.",
      open: "\u00d6ppna",
      hide: "D\u00f6lj assistenten"
    },
    de: {
      ask: "Frag nach einem Spiel, Team oder einer Wette\u2026",
      waiting: "Warte auf Antwort\u2026",
      genericError: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      missingKey: "Fehler: Attribut widget-key fehlt.",
      open: "\u00d6ffnen",
      hide: "Assistent ausblenden"
    },
    pt: {
      ask: "Pergunte sobre qualquer jogo, time ou aposta\u2026",
      waiting: "Aguardando resposta\u2026",
      genericError: "Algo deu errado. Tente novamente.",
      missingKey: "Erro: o atributo widget-key est\u00e1 faltando.",
      open: "Abrir",
      hide: "Ocultar assistente"
    }
  };

  const STYLES = "\n        :host {\n            --om-accent: #8b1a1a;\n            --om-accent-light: #b22a2a;\n            --om-gold: #fecc00;\n            --om-bg: #ffffff;\n            --om-surface: #f5f5f5;\n            --om-border: #e5e5e5;\n            --om-text: #1a1a1a;\n            --om-text-secondary: #666;\n            --om-text-muted: #999;\n            --om-radius: 16px;\n            --om-panel-width: 400px;\n            --om-panel-height: 600px;\n            --om-bottom-offset: 0px;\n            --om-backdrop-color: rgba(0, 0, 0, 0.45);\n            /* Base UI font. Per-client overrides live below (e.g. Lance \u2192\n               IBM Plex Sans). All form controls use font-family:inherit, so\n               this single property cascades through the whole widget. */\n            --om-font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n\n            display: block;\n            position: fixed;\n            /* Default raised near INT32 max so the widget clears branded host\n               headers / sticky chrome (e.g. Svenska Spel Oddset tab bar) which\n               commonly use four-digit z-indices. Override via the z-index\n               attribute if the host needs the widget below specific UI. */\n            z-index: var(--om-z-index, 2147483000);\n            font-family: var(--om-font-family);\n            font-size: 14px;\n            line-height: 1.5;\n        }\n\n        /* Lance matches its site typography (lancecorp.com.br \u2192 IBM Plex Sans).\n           The webfont itself is loaded into the document <head> by _applyFont()\n           when client-id=\"lance\"; this rule just points the stack at it. */\n        :host([client-id=\"lance\"]) {\n            --om-font-family: \"IBM Plex Sans\", -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n        }\n\n        :host([position=\"bottom-right\"]) { bottom: calc(24px + var(--om-bottom-offset)); right: 24px; }\n        :host([position=\"bottom-left\"])  { bottom: calc(24px + var(--om-bottom-offset)); left:  24px; }\n\n        /* \u2500\u2500 Backdrop \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        /* Sits below the panel and dims the host page when the chat is open.\n           Click-to-dismiss. Suppressed entirely when backdrop=\"none\". */\n        .om-backdrop {\n            position: fixed;\n            inset: 0;\n            background: var(--om-backdrop-color);\n            opacity: 0;\n            pointer-events: none;\n            transition: opacity 0.2s ease;\n        }\n        .om-backdrop.open {\n            opacity: 1;\n            pointer-events: auto;\n        }\n        :host([backdrop=\"none\"]) .om-backdrop { display: none; }\n\n        /* \u2500\u2500 FAB Bubble \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-fab {\n            width: 60px;\n            height: 60px;\n            border-radius: 50%;\n            background: linear-gradient(135deg, var(--om-accent), var(--om-accent-light));\n            border: none;\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            box-shadow: 0 4px 20px rgba(139, 26, 26, 0.35);\n            transition: transform 0.2s ease, box-shadow 0.2s ease;\n            position: relative;\n        }\n        .om-fab:hover {\n            transform: scale(1.08);\n            box-shadow: 0 6px 28px rgba(139, 26, 26, 0.45);\n        }\n        .om-fab:active { transform: scale(0.95); }\n        .om-fab svg {\n            width: 28px; height: 28px;\n            fill: var(--om-gold);\n            transition: opacity 0.15s, transform 0.15s;\n        }\n        .om-fab .icon-close { position: absolute; opacity: 0; transform: rotate(-90deg); }\n        .om-fab.open .icon-chat  { opacity: 0; transform: rotate(90deg); }\n        .om-fab.open .icon-close { opacity: 1; transform: rotate(0deg); }\n\n        /* \u2500\u2500 Launcher dismiss badge \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        /* A small \"\xD7\" on the collapsed floating launcher that hides the whole\n           widget for this page session (it returns on reload). The header X\n           only collapses an OPEN panel back to the launcher, which then stays\n           pinned to the page corner \u2014 on interactive host pages (e.g. Lance's\n           Copa do Mundo simulator, whose tap targets sit under the launcher)\n           users need a real way to get it off-screen. Shown only when\n           launcher-dismiss is enabled, in floating mode, while collapsed. */\n        .om-dismiss {\n            position: absolute;\n            top: -7px;\n            right: -7px;\n            width: 22px;\n            height: 22px;\n            padding: 0;\n            border: none;\n            border-radius: 50%;\n            background: #3a3a3a;\n            cursor: pointer;\n            display: none;\n            align-items: center;\n            justify-content: center;\n            box-shadow: 0 1px 4px rgba(0,0,0,0.35);\n            z-index: 2;\n        }\n        .om-dismiss svg { width: 12px; height: 12px; fill: #fff; }\n        .om-dismiss:hover { background: #1f1f1f; }\n        :host([position=\"bottom-left\"]) .om-dismiss { right: auto; left: -7px; }\n        :host(.om-launcher-dismissible:not(.om-open):not([mode=\"inline\"])) .om-dismiss { display: flex; }\n\n        /* \u2500\u2500 Chat Panel \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-panel {\n            position: absolute;\n            bottom: 72px;\n            width: var(--om-panel-width);\n            height: var(--om-panel-height);\n            max-height: calc(100vh - 120px);\n            background: var(--om-bg);\n            border-radius: var(--om-radius);\n            box-shadow: 0 12px 48px rgba(0,0,0,0.15), 0 2px 8px rgba(0,0,0,0.08);\n            display: flex;\n            flex-direction: column;\n            overflow: hidden;\n            transform: scale(0.9) translateY(20px);\n            opacity: 0;\n            pointer-events: none;\n            transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), opacity 0.2s ease;\n        }\n        :host([position=\"bottom-right\"]) .om-panel { right: 0; }\n        :host([position=\"bottom-left\"])  .om-panel { left: 0; }\n        .om-panel.open {\n            transform: scale(1) translateY(0);\n            opacity: 1;\n            pointer-events: auto;\n        }\n        /* Never let the floating panel exceed the screen on small viewports\n           (its fixed --om-panel-width would otherwise overflow / clip the\n           composer's send button on a phone). No-op on desktop. */\n        :host(:not([mode=\"inline\"])) .om-panel { max-width: calc(100vw - 32px); }\n\n        /* \u2500\u2500 Inline / embedded mode \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        /* mode=\"inline\" drops the floating bubble + backdrop and renders the\n           chat panel directly in the page flow, always open. The host element\n           becomes the sized container \u2014 control its size with the width and\n           height attributes (or the --om-panel-width / --om-panel-height\n           custom properties). Intended for dedicated chat pages / sections\n           (e.g. a \"/ai\" sub-page) rather than the corner bubble. */\n        :host([mode=\"inline\"]) {\n            position: relative;\n            display: block;\n            inset: auto;\n            top: auto; right: auto; bottom: auto; left: auto;\n            width: var(--om-panel-width);\n            height: var(--om-panel-height);\n            max-width: 100%;\n        }\n        :host([mode=\"inline\"]) .om-fab,\n        :host([mode=\"inline\"]) .om-backdrop {\n            display: none;\n        }\n        :host([mode=\"inline\"]) .om-panel {\n            position: relative;\n            inset: auto;\n            top: auto; right: auto; bottom: auto; left: auto;\n            width: 100%;\n            height: 100%;\n            max-height: 100%;\n            transform: none;\n            opacity: 1;\n            pointer-events: auto;\n        }\n        /* The in-header X collapses an inline embed to the ribbon (below). Hide\n           it only when the host opts out with dismissible=\"false\" \u2014 restoring\n           the legacy always-open, no-close inline behaviour. */\n        :host([mode=\"inline\"][dismissible=\"false\"]) .om-header-close { display: none; }\n\n        /* \u2500\u2500 Inline collapse \"ribbon\" \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        /* The inline analogue of the floating FAB: when an inline embed is\n           dismissed, the always-open panel collapses to this slim, clickable\n           bar and the host element shrinks to the bar's height so the page\n           reflows around it. Clicking the ribbon re-expands the chat. Only\n           ever shown for a collapsed inline embed. */\n        .om-ribbon {\n            display: none;\n            width: 100%;\n            box-sizing: border-box;\n            align-items: center;\n            gap: 12px;\n            padding: 14px 18px;\n            border: none;\n            border-radius: var(--om-radius);\n            background: linear-gradient(135deg, var(--om-accent), var(--om-accent-light));\n            color: #fff;\n            cursor: pointer;\n            font-family: inherit;\n            text-align: left;\n            box-shadow: 0 6px 20px rgba(0,0,0,0.12);\n            transition: transform 0.15s ease, box-shadow 0.15s ease;\n        }\n        .om-ribbon:hover { transform: translateY(-1px); box-shadow: 0 10px 26px rgba(0,0,0,0.16); }\n        .om-ribbon:active { transform: translateY(0); }\n        .om-ribbon-icon {\n            width: 36px; height: 36px; border-radius: 50%;\n            background: rgba(255,255,255,0.15);\n            display: flex; align-items: center; justify-content: center;\n            font-size: 18px; flex-shrink: 0;\n        }\n        .om-ribbon-icon img { width: 100%; height: 100%; object-fit: contain; border-radius: 50%; }\n        .om-ribbon-text { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }\n        .om-ribbon-title {\n            font-size: 15px; font-weight: 700; letter-spacing: -0.01em;\n            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n        }\n        .om-ribbon-subtitle {\n            font-size: 11px; opacity: 0.85; font-weight: 400;\n            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;\n        }\n        .om-ribbon-cta {\n            display: flex; align-items: center; gap: 6px; flex-shrink: 0;\n            font-size: 12px; font-weight: 700;\n            background: rgba(255,255,255,0.18); padding: 7px 12px; border-radius: 999px;\n        }\n        .om-ribbon-cta svg { width: 15px; height: 15px; fill: currentColor; }\n\n        /* Collapsed inline embed: shrink the host, hide the panel, show ribbon. */\n        :host([mode=\"inline\"].om-collapsed) { height: auto; }\n        :host([mode=\"inline\"].om-collapsed) .om-panel { display: none; }\n        :host([mode=\"inline\"].om-collapsed) .om-ribbon { display: flex; }\n\n        /* \u2500\u2500 Cross-instance coordination \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n           A page may embed several <oddsmind-chat> elements (e.g. lance places\n           the inline co-brand embed at multiple spots in an article). Each\n           renders its own launcher pill, so expanding one would otherwise leave\n           the others' pills stacked directly above/below the open panel. While\n           one instance is the active (open) chat, every OTHER instance gets this\n           class and is removed from flow entirely \u2014 no sandwiching pills.\n           Restored when the active instance collapses. See _notifyOpened /\n           _suppress. */\n        :host(.om-suppressed) { display: none !important; }\n        /* Dismissed via the launcher \xD7 \u2014 hidden for the rest of this page\n           session (a fresh element on reload starts visible again). */\n        :host(.om-dismissed) { display: none !important; }\n\n        /* \u2500\u2500 White-label launcher + header artwork \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n           Opt-in via launcher-image-url / launcher-image-url-mobile /\n           header-image-url. The branding step sets each <img>'s src and adds\n           the matching host class; these rules then swap the default gradient\n           ribbon / header chrome for the client's artwork. Used by\n           client-id=\"lance\" (bet365 co-brand). Images keep height:auto so the\n           container matches the asset's own aspect ratio \u2014 no hardcoded sizes. */\n        .om-brand-img { display: none; }\n\n        /* Launcher = the opening button: the floating FAB (mode=\"floating\") OR\n           the inline collapse ribbon (mode=\"inline\"). Same artwork for both, so\n           it works however lance embeds the component. Strip the default\n           gradient/round chrome and hide the built-in icons/text.\n\n           IMPORTANT: this only RESTYLES the launcher \u2014 it must NOT set display.\n           Visibility stays owned by the mode/collapsed rules above. A blanket\n           display:block here used to leak through both ways: it out-ordered the\n           inline FAB hide (:host([mode=\"inline\"]) .om-fab), so every inline embed\n           rendered a stray FAB pill next to its ribbon (two launchers); and it\n           out-specified the base .om-ribbon display:none, so the ribbon lingered\n           above the panel even while the chat was open. */\n        :host(.om-has-launcher-img) .om-fab,\n        :host(.om-has-launcher-img) .om-ribbon {\n            width: auto; height: auto;\n            padding: 0; background: none; box-shadow: none;\n            border-radius: 0; line-height: 0;\n        }\n        /* Restore the floating FAB's block display (the only launcher that lives\n           outside inline mode). Inline keeps the FAB hidden and lets the\n           collapsed-ribbon rule own the ribbon's visibility. */\n        :host(.om-has-launcher-img:not([mode=\"inline\"])) .om-fab { display: block; }\n        :host(.om-has-launcher-img) .om-fab:hover,\n        :host(.om-has-launcher-img) .om-ribbon:hover { transform: none; box-shadow: none; }\n        :host(.om-has-launcher-img) .om-fab .icon-chat,\n        :host(.om-has-launcher-img) .om-fab .icon-close,\n        :host(.om-has-launcher-img) .om-ribbon-icon,\n        :host(.om-has-launcher-img) .om-ribbon-text,\n        :host(.om-has-launcher-img) .om-ribbon-cta { display: none; }\n        /* Floating FAB: the pill at its own size (capped, overridable). Inline\n           ribbon: the pill spans the embed's full width. */\n        :host(.om-has-launcher-img) .om-fab .om-launcher-img--desktop {\n            display: block; height: auto; width: var(--om-launcher-width, 300px); max-width: 80vw;\n        }\n        :host(.om-has-launcher-img) .om-ribbon .om-launcher-img--desktop {\n            display: block; height: auto; width: 100%;\n        }\n\n        /* Mobile: swap the pill for the minimalist round button so it doesn't\n           crowd the content. Only when a mobile asset is supplied \u2014 otherwise\n           the desktop pill stays at every width. */\n        @media (max-width: 600px) {\n            /* (iOS zoom-on-focus fix lives after the base .om-input rule \u2014 a\n               @media override here loses the cascade tie to it and does nothing.) */\n            /* Scope to .om-fab/.om-ribbon so these tie the (0,3,0) specificity of\n               the desktop-image show rules above; with the media query coming\n               later in source, the hide then wins. Without the .om-fab/.om-ribbon\n               scope the hide is only (0,2,0) and loses, so the desktop pill never\n               disappears and the mobile button never takes over. */\n            :host(.om-has-launcher-mobile) .om-fab .om-launcher-img--desktop,\n            :host(.om-has-launcher-mobile) .om-ribbon .om-launcher-img--desktop { display: none; }\n            :host(.om-has-launcher-mobile) .om-fab .om-launcher-img--mobile,\n            :host(.om-has-launcher-mobile) .om-ribbon .om-launcher-img--mobile {\n                display: block; width: auto; height: auto;\n                max-height: var(--om-launcher-mobile-size, 56px); margin: 0 0 0 auto;\n            }\n            /* The inline ribbon is a <button>, so it shrinks to the compact\n               mobile image (fit-content) and would sit at the left. Force it\n               full-width on mobile so margin-left:auto on the image above can\n               push the button to the right edge. */\n            :host(.om-has-launcher-mobile) .om-ribbon { width: 100%; }\n        }\n\n        /* Header bar artwork. The close (X) drawn into the asset is backed by\n           the real, transparent .om-header-close hot-zone on the right so it\n           stays clickable. */\n        :host(.om-has-header-img) .om-header { position: relative; padding: 0; background: none; display: block; }\n        :host(.om-has-header-img) .om-header-img { display: block; width: 100%; height: auto; }\n        :host(.om-has-header-img) .om-header-icon,\n        :host(.om-has-header-img) .om-header-text,\n        :host(.om-has-header-img) .om-header-min,\n        :host(.om-has-header-img) .om-header-fs { display: none; }\n        :host(.om-has-header-img) .om-header-close {\n            position: absolute; top: 0; right: 0; height: 100%;\n            width: 64px; background: transparent; border-radius: 0;\n        }\n        :host(.om-has-header-img) .om-header-close:hover { background: rgba(0,0,0,0.06); }\n        :host(.om-has-header-img) .om-header-close svg { opacity: 0; }\n\n        /* \u2500\u2500 Header \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-header {\n            padding: 16px 20px;\n            background: linear-gradient(135deg, var(--om-accent), var(--om-accent-light));\n            color: #fff;\n            display: flex;\n            align-items: center;\n            gap: 12px;\n            flex-shrink: 0;\n        }\n        .om-header-icon {\n            width: 36px; height: 36px;\n            border-radius: 50%;\n            background: rgba(255,255,255,0.15);\n            display: flex; align-items: center; justify-content: center;\n            font-size: 18px;\n            flex-shrink: 0;\n        }\n        .om-header-text {\n            flex: 1; min-width: 0;\n        }\n        .om-header-text h3 {\n            margin: 0; font-size: 15px; font-weight: 700; letter-spacing: -0.01em;\n            display: flex; align-items: center; gap: 7px;\n        }\n        .om-header-text p {\n            margin: 0; font-size: 11px; opacity: 0.8; font-weight: 400;\n        }\n        .om-header-icon img { width: 100%; height: 100%; object-fit: contain; border-radius: 50%; }\n        .om-badge {\n            font-size: 9px; font-weight: 700; line-height: 1; letter-spacing: 0.06em;\n            text-transform: uppercase; padding: 3px 6px; border-radius: 6px;\n            background: rgba(255,255,255,0.22); color: #fff; flex-shrink: 0;\n        }\n        .om-badge[hidden] { display: none; }\n        /* In-header close button \u2014 primary affordance on mobile, where the\n           full-screen panel covers the FAB. Visible on desktop too as a\n           familiar X-to-close shortcut. */\n        .om-header-close {\n            width: 32px; height: 32px;\n            border-radius: 50%;\n            background: rgba(255,255,255,0.15);\n            border: none;\n            color: #fff;\n            cursor: pointer;\n            display: flex; align-items: center; justify-content: center;\n            flex-shrink: 0;\n            padding: 0;\n            transition: background 0.15s;\n        }\n        .om-header-close:hover { background: rgba(255,255,255,0.28); }\n        .om-header-close svg { width: 16px; height: 16px; fill: currentColor; }\n        /* Minimize button \u2014 collapses the chat back to the launcher. Hidden by\n           default; surfaced only on the anchored/short-viewport layout (see the\n           tablet @media block), where the panel is lowered over the FAB so the\n           header becomes the dismiss affordance. Mirrors the close button. */\n        .om-header-min {\n            display: none;\n            width: 32px; height: 32px; border-radius: 50%;\n            background: rgba(255,255,255,0.15); border: none; color: #fff;\n            cursor: pointer; align-items: center; justify-content: center;\n            flex-shrink: 0; padding: 0; transition: background 0.15s;\n        }\n        .om-header-min:hover { background: rgba(255,255,255,0.28); }\n        .om-header-min svg { width: 18px; height: 18px; fill: currentColor; }\n        /* Fullscreen toggle \u2014 opt-in via allow-fullscreen. Mirrors the close button. */\n        .om-header-fs {\n            width: 32px; height: 32px; border-radius: 50%;\n            background: rgba(255,255,255,0.15); border: none; color: #fff;\n            cursor: pointer; display: flex; align-items: center; justify-content: center;\n            flex-shrink: 0; padding: 0; transition: background 0.15s;\n        }\n        .om-header-fs:hover { background: rgba(255,255,255,0.28); }\n        .om-header-fs svg { width: 16px; height: 16px; fill: currentColor; }\n        .om-header-fs[hidden] { display: none; }\n        /* Icon swaps to a \"minimize/exit\" glyph while fullscreen, so there's a\n           clear way back \u2014 important in inline mode, where the X-close is hidden. */\n        .om-header-fs .om-fs-close { display: none; }\n        .om-panel.om-fullscreen .om-header-fs .om-fs-open { display: none; }\n        .om-panel.om-fullscreen .om-header-fs .om-fs-close { display: inline; }\n        /* Fullscreen panel \u2014 covers the viewport regardless of floating/inline mode. */\n        .om-panel.om-fullscreen {\n            position: fixed !important; inset: 0 !important;\n            width: 100% !important; height: 100% !important;\n            max-width: 100% !important; max-height: 100% !important;\n            border-radius: 0 !important; z-index: 2147483646;\n        }\n\n        /* \u2500\u2500 Messages Area \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-messages {\n            flex: 1;\n            overflow-y: auto;\n            padding: 16px;\n            display: flex;\n            flex-direction: column;\n            gap: 12px;\n            scroll-behavior: smooth;\n        }\n        .om-messages::-webkit-scrollbar { width: 4px; height: 4px; }\n        .om-messages::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }\n\n        .om-msg {\n            max-width: 85%;\n            padding: 10px 14px;\n            border-radius: 12px;\n            font-size: 13px;\n            line-height: 1.55;\n            word-wrap: break-word;\n            animation: om-fadein 0.2s ease-out;\n        }\n        .om-msg.user {\n            align-self: flex-end;\n            background: var(--om-accent); color: #fff;\n            border-bottom-right-radius: 4px;\n        }\n        .om-msg.bot {\n            align-self: flex-start;\n            background: var(--om-surface); color: var(--om-text);\n            border-bottom-left-radius: 4px;\n        }\n        .om-msg.bot strong { font-weight: 600; }\n        .om-msg.bot em { font-style: italic; }\n        .om-msg.bot code {\n            background: rgba(0,0,0,0.06); padding: 1px 4px; border-radius: 3px; font-size: 12px;\n        }\n        .om-msg.bot a { color: var(--om-accent-light); text-decoration: none; }\n        .om-msg.bot a:hover { text-decoration: underline; }\n        .om-msg.bot h1, .om-msg.bot h2, .om-msg.bot h3, .om-msg.bot h4 {\n            margin: 8px 0 4px; font-weight: 700;\n        }\n        .om-msg.bot h1 { font-size: 16px; }\n        .om-msg.bot h2 { font-size: 15px; }\n        .om-msg.bot h3 { font-size: 14px; }\n        .om-msg.bot h4 { font-size: 13px; }\n        .om-msg.bot ul, .om-msg.bot ol { margin: 4px 0; padding-left: 18px; }\n        .om-msg.bot li { margin-bottom: 2px; }\n        .om-msg.bot table {\n            width: 100%; border-collapse: collapse; font-size: 12px; margin: 8px 0;\n        }\n        .om-msg.bot th, .om-msg.bot td {\n            padding: 6px 8px; border-bottom: 1px solid var(--om-border); text-align: left;\n        }\n        .om-msg.bot th {\n            font-weight: 600; background: rgba(0,0,0,0.03);\n            font-size: 10px; text-transform: uppercase; letter-spacing: 0.04em;\n        }\n        .om-msg.bot blockquote {\n            border-left: 3px solid var(--om-accent); padding-left: 10px;\n            margin: 4px 0; color: var(--om-text-secondary);\n        }\n        .om-msg.bot hr { border: none; border-top: 1px solid var(--om-border); margin: 8px 0; }\n        .om-msg .widgets-container { margin-top: 8px; }\n\n        /* \u2500\u2500 Follow-up Chips \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-chips {\n            display: flex; flex-wrap: wrap; gap: 6px; margin-top: 8px;\n        }\n        .om-chip {\n            font-family: inherit; font-size: 12px;\n            padding: 6px 12px; border-radius: 999px;\n            border: 1px solid var(--om-border); background: #fff; color: var(--om-text);\n            cursor: pointer; transition: background 0.15s, border-color 0.15s;\n        }\n        .om-chip:hover {\n            background: var(--om-surface); border-color: var(--om-accent); color: var(--om-accent);\n        }\n\n        /* \u2500\u2500 Initial Quick-Question Chips \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-intro-chips {\n            display: flex; flex-wrap: wrap; gap: 8px; padding: 8px 0 4px;\n            opacity: 0; transition: opacity 0.5s;\n        }\n        .om-intro-chip {\n            padding: 8px 16px; border-radius: 999px;\n            border: 1px solid var(--om-border);\n            background: rgba(139, 26, 26, 0.06); color: var(--om-accent);\n            font-size: 13px; font-family: inherit; cursor: pointer;\n            /* wrap long chips so they never overflow the narrow floating panel\n               (overflow caused a stray grey horizontal scrollbar on .om-messages) */\n            transition: all 0.2s; white-space: normal; max-width: 100%;\n            text-align: left; line-height: 1.35;\n        }\n        .om-intro-chip:hover {\n            background: rgba(139, 26, 26, 0.12); border-color: var(--om-accent);\n        }\n\n        /* \u2500\u2500 Age gate (18+) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-age-btns { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 10px; }\n        .om-age-btn {\n            font-family: inherit; font-size: 13px; font-weight: 700;\n            padding: 9px 18px; border-radius: 999px; border: 1px solid var(--om-border);\n            cursor: pointer; transition: background 0.15s, border-color 0.15s, opacity 0.15s;\n        }\n        .om-age-btn.yes { background: var(--om-accent); color: #fff; border-color: var(--om-accent); }\n        .om-age-btn.yes:hover { background: var(--om-accent-light); border-color: var(--om-accent-light); }\n        .om-age-btn.no { background: #fff; color: var(--om-text-secondary); }\n        .om-age-btn.no:hover { border-color: var(--om-text-secondary); color: var(--om-text); }\n        .om-age-btn:disabled { opacity: 0.5; cursor: default; }\n        .om-age-blocked { margin-top: 10px; font-size: 12px; font-weight: 600; color: #c0392b; }\n        .om-age-note { margin-top: 10px; font-size: 12px; font-weight: 500; color: var(--om-text-muted); }\n\n        /* \u2500\u2500 Action Container (below bot messages) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-actions {\n            align-self: flex-start;\n            display: flex; flex-direction: column; gap: 6px;\n            margin-top: -8px; margin-left: 6px; max-width: 90%;\n        }\n\n        /* \u2500\u2500 Feedback Buttons \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-feedback-row { display: flex; gap: 4px; align-items: center; }\n        .om-feedback-btn {\n            width: 28px; height: 28px; border-radius: 50%;\n            border: 1px solid var(--om-border); background: #fff;\n            color: #888; font-size: 13px; line-height: 1;\n            cursor: pointer; transition: all 0.15s;\n            display: flex; align-items: center; justify-content: center;\n            padding: 0; font-family: inherit;\n        }\n        .om-feedback-btn:hover { border-color: var(--om-accent); color: var(--om-accent); }\n        .om-feedback-btn.active-up {\n            background: rgba(0, 184, 148, 0.12); border-color: #00b894; color: #00b894;\n        }\n        .om-feedback-btn.active-down {\n            background: rgba(231, 76, 60, 0.12); border-color: #e74c3c; color: #e74c3c;\n        }\n        .om-feedback-btn:disabled { opacity: 0.5; cursor: default; }\n\n        .om-feedback-comment {\n            display: flex; flex-direction: column; gap: 6px; margin-top: 4px; max-width: 320px;\n        }\n        .om-feedback-comment textarea {\n            width: 100%; min-height: 56px; padding: 8px 10px;\n            border: 1px solid var(--om-border); border-radius: 8px;\n            font-family: inherit; font-size: 12px; line-height: 1.4;\n            color: var(--om-text); background: #fff; resize: vertical; outline: none;\n            transition: border-color 0.15s, box-shadow 0.15s;\n        }\n        .om-feedback-comment textarea:focus {\n            border-color: var(--om-accent); box-shadow: 0 0 0 3px rgba(139, 26, 26, 0.08);\n        }\n        .om-feedback-comment-row { display: flex; align-items: center; gap: 6px; }\n        .om-feedback-comment-send {\n            padding: 6px 12px; background: var(--om-accent); color: #fff;\n            border: none; border-radius: 999px; font-family: inherit;\n            font-size: 11px; font-weight: 700; cursor: pointer; transition: background 0.15s;\n        }\n        .om-feedback-comment-send:hover:not(:disabled) { background: var(--om-accent-light); }\n        .om-feedback-comment-send:disabled { opacity: 0.5; cursor: not-allowed; }\n        .om-feedback-comment-skip {\n            padding: 6px 10px; background: transparent; color: var(--om-text-muted);\n            border: none; font-family: inherit; font-size: 11px; cursor: pointer;\n            text-decoration: underline;\n        }\n        .om-feedback-comment-skip:hover { color: var(--om-text-secondary); }\n        .om-feedback-comment-thanks { color: #00966f; font-size: 11px; font-weight: 600; }\n\n        /* \u2500\u2500 Bookmaker CTA (Bet Card) \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-bet-ctas {\n            display: flex; flex-direction: column; gap: 8px; margin-top: 6px;\n        }\n        .om-bet-ctas-label {\n            display: inline-flex; align-items: center; gap: 6px;\n            font-size: 11px; font-weight: 700; color: var(--om-accent);\n            letter-spacing: 0.1em; text-transform: uppercase;\n        }\n        .om-bet-ctas-label::before {\n            content: ''; display: inline-block; width: 6px; height: 6px; border-radius: 50%;\n            background: var(--om-accent); box-shadow: 0 0 0 3px rgba(139, 26, 26, 0.18);\n            animation: om-pulse-accent 2s ease-in-out infinite;\n        }\n        @keyframes om-pulse-accent {\n            0%, 100% { box-shadow: 0 0 0 3px rgba(139, 26, 26, 0.18); }\n            50%      { box-shadow: 0 0 0 6px rgba(139, 26, 26, 0.08); }\n        }\n        .om-bet-cta-btn {\n            display: flex; align-items: center; justify-content: space-between; gap: 12px;\n            padding: 14px 18px; border-radius: 14px;\n            background: linear-gradient(135deg, var(--om-accent) 0%, var(--om-accent-light) 100%);\n            color: #fff; text-decoration: none; font-size: 14px; font-weight: 700;\n            letter-spacing: 0.01em;\n            box-shadow: 0 6px 18px rgba(139, 26, 26, 0.32);\n            transition: transform 0.2s, box-shadow 0.2s, background 0.2s;\n            position: relative; overflow: hidden;\n        }\n        .om-bet-cta-btn::before {\n            content: ''; position: absolute; inset: 0;\n            background: linear-gradient(120deg, transparent 30%, rgba(255,255,255,0.18) 50%, transparent 70%);\n            transform: translateX(-100%);\n            transition: transform 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n        }\n        .om-bet-cta-btn:hover::before { transform: translateX(100%); }\n        .om-bet-cta-btn:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 12px 28px rgba(139, 26, 26, 0.42);\n            background: linear-gradient(135deg, #6e1414 0%, var(--om-accent) 100%);\n        }\n        .om-bet-cta-main {\n            display: flex; flex-direction: column; gap: 2px;\n            align-items: flex-start; min-width: 0; flex: 1;\n        }\n        .om-bet-cta-kicker {\n            font-size: 10px; font-weight: 700; letter-spacing: 0.12em;\n            text-transform: uppercase; opacity: 0.85;\n        }\n        .om-bet-cta-text {\n            font-size: 14px; font-weight: 700; line-height: 1.3;\n            overflow: hidden; text-overflow: ellipsis;\n            display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2;\n            -webkit-box-orient: vertical;\n        }\n        .om-bet-cta-subs {\n            font-size: 11px; font-weight: 500; opacity: 0.82; margin-top: 4px; line-height: 1.35;\n            overflow: hidden; text-overflow: ellipsis;\n            display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2;\n            -webkit-box-orient: vertical;\n        }\n        .om-bet-cta-arrow {\n            font-size: 18px; font-weight: 700; flex-shrink: 0; transition: transform 0.2s;\n        }\n        .om-bet-cta-btn:hover .om-bet-cta-arrow { transform: translateX(4px); }\n\n        /* Inline odds-value link \u2014 when bookmaker_cta arrives with an\n           odds_decimal we can locate in the prose, the matching number is\n           wrapped in this anchor so the user can click the odds itself. */\n        .om-bet-cta-inline {\n            display: inline !important;\n            color: var(--om-accent);\n            font-weight: 700;\n            text-decoration: underline;\n            text-decoration-style: dotted;\n            text-underline-offset: 3px;\n            cursor: pointer;\n        }\n        .om-bet-cta-inline:hover {\n            color: var(--om-accent-light);\n            text-decoration-style: solid;\n        }\n\n        /* \u2500\u2500 Status indicator \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-status {\n            padding: 0 16px 4px; font-size: 11px;\n            color: var(--om-text-muted); min-height: 18px;\n            display: inline-flex; align-items: baseline; gap: 6px;\n            transition: opacity 0.18s ease;\n        }\n        /* Brief fade on filler-message swaps \u2014 purely decorative; real\n           backend status events get instant text updates so they don't trail\n           the underlying pipeline. */\n        .om-status.swapping { opacity: 0; }\n\n        /* Three small bouncing dots beside the status text \u2014 visible heartbeat\n           while waiting for the next event. Pure CSS (opacity + transform);\n           GPU-accelerated, no JS tick, no layout cost. */\n        .om-status-dots {\n            display: inline-flex; align-items: center; gap: 3px;\n            vertical-align: baseline; transform: translateY(-1px);\n        }\n        .om-status-dots span {\n            display: inline-block; width: 4px; height: 4px;\n            border-radius: 50%; background: currentColor;\n            opacity: 0.35;\n            animation: om-dot-bounce 1.05s ease-in-out infinite;\n        }\n        .om-status-dots span:nth-child(2) { animation-delay: 0.16s; }\n        .om-status-dots span:nth-child(3) { animation-delay: 0.32s; }\n        @keyframes om-dot-bounce {\n            0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }\n            40%           { opacity: 0.9;  transform: translateY(-3px); }\n        }\n\n        /* \u2500\u2500 Input Area \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-input-row {\n            display: flex; align-items: center; gap: 8px;\n            padding: 12px 16px; border-top: 1px solid var(--om-border);\n            padding-bottom: calc(12px + env(safe-area-inset-bottom));\n            background: var(--om-bg); flex-shrink: 0;\n        }\n        .om-input {\n            flex: 1; border: 1px solid var(--om-border); border-radius: 999px;\n            padding: 10px 16px; font-size: 13px; font-family: inherit; outline: none;\n            transition: border-color 0.15s; background: var(--om-surface); color: var(--om-text);\n        }\n        /* iOS Safari zooms the whole page when a focused field is <16px and\n           never zooms back \u2014 the chat opens \"stuck\" zoomed-in (reported on the\n           Lance web-component embed). This MUST come after the base .om-input\n           rule above: an earlier @media override loses the cascade tie to it\n           and silently does nothing. Key off the input device (coarse pointer =\n           touch) so it fires on every phone regardless of how the host page's\n           layout viewport computes \u2014 a width-based @media can miss. */\n        @media (pointer: coarse) {\n            .om-input,\n            .om-feedback-comment textarea { font-size: 16px; }\n        }\n        .om-input:focus { border-color: var(--om-accent); background: #fff; }\n        .om-input::placeholder { color: var(--om-text-muted); }\n        .om-input:disabled { opacity: 0.6; cursor: not-allowed; }\n\n        .om-send {\n            width: 36px; height: 36px; border-radius: 50%; border: none;\n            background: var(--om-accent); cursor: pointer;\n            display: flex; align-items: center; justify-content: center;\n            transition: background 0.15s, transform 0.1s; flex-shrink: 0;\n        }\n        .om-send:hover { background: var(--om-accent-light); }\n        .om-send:active { transform: scale(0.9); }\n        .om-send:disabled { opacity: 0.5; cursor: not-allowed; }\n        .om-send svg { width: 16px; height: 16px; fill: #fff; }\n\n        /* \u2500\u2500 Powered-by footer \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        .om-footer {\n            text-align: center; font-size: 10px; color: var(--om-text-muted);\n            padding: 6px 16px 10px; flex-shrink: 0;\n        }\n        .om-footer a { color: var(--om-accent); text-decoration: none; font-weight: 600; }\n        .om-footer-note { display: block; margin-bottom: 3px; }\n        .om-footer-rg { display: block; margin-bottom: 3px; }\n\n        /* \u2500\u2500 Animations \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        @keyframes om-fadein {\n            from { opacity: 0; transform: translateY(4px); }\n            to   { opacity: 1; transform: translateY(0); }\n        }\n\n        /* \u2500\u2500 Mobile: full-screen panel \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500 */\n        /* Floating mode only \u2014 an inline embed keeps the size the host page\n           gave it (it lives inside the page layout, not over it).\n           max-width MUST be re-declared here: the small-viewport gutter cap\n           above (':host(:not([mode=\"inline\"])) .om-panel') ties on specificity\n           and would otherwise keep the \"full-screen\" panel 32px short of the\n           viewport edge (reported by Svenska Spel on 0.18.0).\n           top/bottom honour the host-chrome offsets: chrome like Oddset's\n           Spelpaus bar is compliance-pinned above ANY z-index we set, so\n           instead of losing that stacking fight the panel lays out between\n           top-offset and bottom-offset \u2014 keeping our own header (close \xD7) and\n           composer reachable. Both default to 0px = true full bleed, so embeds\n           that don't set the attributes are unchanged. */\n        @media (max-width: 480px) {\n            :host(:not([mode=\"inline\"])) .om-panel {\n                position: fixed;\n                top: var(--om-top-offset, 0px);\n                right: 0;\n                bottom: var(--om-bottom-offset, 0px);\n                left: 0;\n                width: 100%;\n                height: auto;\n                max-width: 100%;\n                max-height: 100%;\n                border-radius: 0;\n            }\n            /* Push header below iOS notch / status bar so the OddsMind title\n               isn't clipped on devices with a top safe-area inset. A declared\n               top-offset already clears that inset (the host header occupies\n               it), so only pad whatever part of the inset the offset doesn't\n               cover. */\n            .om-header {\n                padding-top: calc(16px + max(env(safe-area-inset-top, 0px) - var(--om-top-offset, 0px), 0px));\n            }\n        }\n\n        /* \u2500\u2500 Tablet / short viewport: anchor below host top chrome \u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\n           Above the 480px mobile breakpoint the floating panel stays a corner\n           popup. But on SHORT viewports (landscape iPad, laptops) the panel hits\n           its max-height and its top \u2014 the widget's own header with the close\n           button \u2014 is pushed up behind the host page's sticky top header. A host\n           bottom-offset (e.g. Svenska Spel's Oddset tab bar) makes it worse,\n           shoving the header clean off the top of the viewport so the chat can\n           only be closed from the FAB. When the host declares a top clearance\n           (top-offset attribute, or implicitly client-id=\"svenskaspel\" \u2192 the\n           om-anchored class), we pin the panel with position:fixed between that\n           clearance and the host bottom chrome, lower it over the FAB (it no\n           longer reserves FAB space), hide the now-covered FAB, and surface the\n           in-header minimize button so the chat is always dismissible from the\n           visible header. Other clients are untouched (no om-anchored class).\n           Ceiling at 1024px tall: covers iPad (portrait+landscape) and laptops,\n           where a tall host header (Oddset: 118px signed-in) + bottom betslip\n           still collide; above it the popup has ample top clearance. The default\n           120px top clearance clears Oddset's signed-in header out of the box,\n           but hosts should set top-offset to their real (state-dependent) header\n           height \u2014 it updates live (see _applyTopOffset). */\n        @media (min-width: 481px) and (max-height: 1024px) {\n            :host(.om-anchored:not([mode=\"inline\"])) .om-panel {\n                position: fixed;\n                top: var(--om-top-offset, 120px);\n                bottom: calc(16px + var(--om-bottom-offset, 0px));\n                height: auto;\n                max-height: none;\n                max-width: calc(100vw - 48px);\n            }\n            :host([position=\"bottom-right\"].om-anchored:not([mode=\"inline\"])) .om-panel { right: 24px; left: auto; }\n            :host([position=\"bottom-left\"].om-anchored:not([mode=\"inline\"]))  .om-panel { left: 24px; right: auto; }\n            /* The lowered panel covers the FAB; the header minimize button is the\n               dismiss affordance, so hide the FAB while open to avoid a stray\n               bubble peeking out (it returns when the chat is minimized). */\n            :host(.om-anchored:not([mode=\"inline\"])) .om-fab.open { display: none; }\n            :host(.om-anchored:not([mode=\"inline\"])) .om-header-min { display: flex; }\n        }\n    ";

  const TEMPLATE = "\n        <div class=\"om-backdrop\" aria-hidden=\"true\"></div>\n        <button class=\"om-fab\" aria-label=\"Open chat\">\n            <img class=\"om-brand-img om-launcher-img om-launcher-img--desktop\" alt=\"\" />\n            <img class=\"om-brand-img om-launcher-img om-launcher-img--mobile\" alt=\"\" />\n            <svg class=\"icon-chat\" viewBox=\"0 0 24 24\"><path d=\"M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z\"/></svg>\n            <svg class=\"icon-close\" viewBox=\"0 0 24 24\"><path d=\"M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z\"/></svg>\n        </button>\n        <button class=\"om-dismiss\" type=\"button\" aria-label=\"Hide\">\n            <svg viewBox=\"0 0 24 24\"><path d=\"M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z\"/></svg>\n        </button>\n        <div class=\"om-panel\">\n            <div class=\"om-header\">\n                <img class=\"om-brand-img om-header-img\" alt=\"\" />\n                <div class=\"om-header-icon\">\u26BD</div>\n                <div class=\"om-header-text\">\n                    <h3><span class=\"om-title\">OddsMind</span><span class=\"om-badge\" hidden></span></h3>\n                    <p>AI Betting Assistant</p>\n                </div>\n                <button class=\"om-header-fs\" type=\"button\" aria-label=\"Fullscreen\" hidden>\n                    <svg class=\"om-fs-open\" viewBox=\"0 0 24 24\"><path d=\"M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z\"/></svg>\n                    <svg class=\"om-fs-close\" viewBox=\"0 0 24 24\"><path d=\"M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z\"/></svg>\n                </button>\n                <button class=\"om-header-min\" type=\"button\" aria-label=\"Minimize chat\">\n                    <svg viewBox=\"0 0 24 24\"><path d=\"M7 10l5 5 5-5z\"/></svg>\n                </button>\n                <button class=\"om-header-close\" type=\"button\" aria-label=\"Close chat\">\n                    <svg viewBox=\"0 0 24 24\"><path d=\"M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6z\"/></svg>\n                </button>\n            </div>\n            <div class=\"om-messages\"></div>\n            <div class=\"om-status\"></div>\n            <div class=\"om-input-row\">\n                <input class=\"om-input\" type=\"text\" placeholder=\"Ask about any match, team, or bet\u2026\" autocomplete=\"off\" />\n                <button class=\"om-send\" aria-label=\"Send message\">\n                    <svg viewBox=\"0 0 24 24\"><path d=\"M2.01 21L23 12 2.01 3 2 10l15 2-15 2z\"/></svg>\n                </button>\n            </div>\n            <div class=\"om-footer\">\n                <span class=\"om-footer-note\"></span>\n                <span class=\"om-footer-rg\"></span>\n                <span class=\"om-footer-credit\"><span class=\"om-footer-prefix\">Powered by </span><a href=\"https://oddsmind.ai\" target=\"_blank\" rel=\"noopener noreferrer\">OddsMind</a></span>\n            </div>\n        </div>\n        <button class=\"om-ribbon\" type=\"button\" aria-label=\"Open chat\">\n            <img class=\"om-brand-img om-launcher-img om-launcher-img--desktop\" alt=\"\" />\n            <img class=\"om-brand-img om-launcher-img om-launcher-img--mobile\" alt=\"\" />\n            <span class=\"om-ribbon-icon\">\u26BD</span>\n            <span class=\"om-ribbon-text\">\n                <span class=\"om-ribbon-title\">OddsMind</span>\n                <span class=\"om-ribbon-subtitle\">AI Betting Assistant</span>\n            </span>\n            <span class=\"om-ribbon-cta\">\n                <span class=\"om-ribbon-cta-label\">Open</span>\n                <svg viewBox=\"0 0 24 24\"><path d=\"M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.2L4 17.2V4h16v12z\"/></svg>\n            </span>\n        </button>\n    ";

  const CHIP_TEMPLATES = {
    en: {
      welcome: "Hi! I’m your AI assistant for football betting — currently focused on the 2026 World Cup. Ask me about any match, team or player and I’ll find value for you. Other sports aren’t supported yet.",
      aiDisclaimer: "AI can make mistakes.",
      responsible: "Gamble responsibly — there is no guarantee of winnings.",
      tip: "Give me a betting tip",
      acca: "Build me an accumulator",
      team: t => "What's a good bet for " + t + "'s next match?",
      generic: (h, a) => "What's a good bet for " + h + " vs " + a + "?",
      fallback: "What's on today?",
      fillers: ["Pulling the latest stats\u2026", "Comparing live odds\u2026", "Checking recent form\u2026", "Looking at the injury list\u2026", "Weighing the value\u2026", "Almost there \u2014 thanks for hanging on\u2026"]
    },
    sv: {
      welcome: "Hej! Jag är din AI-assistent för spel på fotboll — just nu med fokus på VM 2026. Fråga mig om en match, ett lag eller en spelare så ger jag dig statistik och ett spelförslag. Jag kan inte allt ännu, men lär mig hela tiden!",
      aiDisclaimer: "AI kan göra misstag.",
      responsible: "Spela ansvarsfullt — det finns ingen garanti för vinst.",
      tip: "Ge mig ett speltips",
      acca: "Bygg en kombination \u00E5t mig",
      team: t => "Vad \u00E4r ett bra spel p\u00E5 " + t + "s n\u00E4sta match?",
      generic: (h, a) => "Vad \u00E4r ett bra spel p\u00E5 " + h + " mot " + a + "?",
      fallback: "Vilka matcher spelas idag?",
      fillers: ["H\u00E4mtar f\u00E4rsk statistik\u2026", "J\u00E4mf\u00F6r oddsen live\u2026", "Tittar p\u00E5 formen\u2026", "Kollar skadelistan\u2026", "V\u00E4ger v\u00E4rdet\u2026", "Snart klar \u2014 tack f\u00F6r t\u00E5lamodet\u2026"]
    },
    de: {
      welcome: "Hallo! Ich bin dein KI-Assistent für Fußballwetten — aktuell mit Fokus auf die WM 2026. Frag mich zu jedem Spiel, Team oder Spieler und ich finde Value für dich. Andere Sportarten werden noch nicht unterstützt.",
      aiDisclaimer: "KI kann Fehler machen.",
      responsible: "Spiele verantwortungsbewusst — es gibt keine Gewinngarantie.",
      tip: "Gib mir einen Wett-Tipp",
      acca: "Bau mir einen Kombi-Schein",
      team: t => "Was ist ein guter Tipp f\u00FCr " + t + "s n\u00E4chstes Spiel?",
      generic: (h, a) => "Was ist ein guter Tipp f\u00FCr " + h + " gegen " + a + "?",
      fallback: "Welche Spiele sind heute?",
      fillers: ["Hole die aktuellsten Statistiken\u2026", "Vergleiche Live-Quoten\u2026", "Schaue mir die Form an\u2026", "Werte die Verletzungsliste aus\u2026", "W\u00E4ge das Value ab\u2026", "Gleich so weit \u2014 danke f\u00FCrs Warten\u2026"]
    },
    pt: {
      welcome: "Oi! Eu sou seu assistente de IA para apostas de futebol \u2014 no momento com foco na Copa do Mundo de 2026. Pergunte sobre qualquer jogo, time ou jogador e eu encontro valor para voc\u00EA. Outros esportes ainda n\u00E3o s\u00E3o suportados.",
      aiDisclaimer: "A IA pode cometer erros.",
      responsible: "Jogue com responsabilidade, não há garantia de ganhos.",
      tip: "Me d\u00EA uma dica de aposta",
      acca: "Monte uma m\u00FAltipla para mim",
      team: t => "Qual \u00E9 uma boa aposta para o pr\u00F3ximo jogo do " + t + "?",
      generic: (h, a) => "Qual \u00E9 uma boa aposta para " + h + " x " + a + "?",
      fallback: "Quais jogos t\u00EAm hoje?",
      fillers: ["Buscando as estat\u00EDsticas mais recentes\u2026", "Comparando odds ao vivo\u2026", "Conferindo a forma recente\u2026", "Olhando a lista de lesionados\u2026", "Avaliando o valor\u2026", "Quase l\u00E1 \u2014 obrigado por aguardar\u2026"]
    }
  };

  const COUNTRY_TO_TEAM = {
    DE: "Bayern M\u00FCnchen",
    AT: "Red Bull Salzburg",
    CH: "Young Boys",
    SE: "AIK",
    NO: "Bod\u00F8/Glimt",
    DK: "FC K\u00F8benhavn",
    FI: "HJK",
    GB: "Liverpool",
    UK: "Liverpool",
    IE: "Shamrock Rovers",
    ES: "Real Madrid",
    IT: "Inter",
    FR: "Paris Saint-Germain",
    NL: "Ajax",
    PT: "Porto",
    BE: "Club Brugge",
    PL: "Legia Warsaw",
    TR: "Galatasaray",
    GR: "Olympiacos",
    US: "Inter Miami",
    MX: "Club Am\u00E9rica",
    BR: "Flamengo",
    AR: "Boca Juniors"
  };

  const LANG_TO_COUNTRY = {
    en: "GB",
    de: "DE",
    sv: "SE",
    pt: "BR",
    "pt-BR": "BR"
  };

  const CTA_LABELS = {
    en: {
      quick: "Quick Bet",
      builder: "Bet Builder",
      combo: "Combo Bet",
      placeBet: "Place Bet",
      placeBetNow: "Place Bet Now",
      legs: n => n + " Legs"
    },
    sv: {
      quick: "Snabbspel",
      builder: "Bet Builder",
      combo: "Kombo",
      placeBet: "Spela",
      placeBetNow: "Spela nu",
      legs: n => n + " val"
    },
    de: {
      quick: "Schnellwette",
      builder: "Bet Builder",
      combo: "Kombiwette",
      placeBet: "Wette platzieren",
      placeBetNow: "Jetzt wetten",
      legs: n => n + " Auswahl"
    },
    pt: {
      quick: "Aposta Rápida",
      builder: "Criar Aposta",
      combo: "Múltipla",
      placeBet: "Apostar",
      placeBetNow: "Apostar agora via bet365",
      legs: n => n + " seleções"
    }
  };

  const AGE_GATE_TEXT = {
    en: {
      question: n => "Before we start: this content is intended for users aged " + n + "+. Are you " + n + " or older?",
      confirm: n => "Yes, I'm " + n + "+",
      decline: "No",
      blocked: n => "You must be " + n + " or older to use this service. Please gamble responsibly.",
      placeholder: "Confirm your age to continue…",
      responsible: "Gamble responsibly — there is no guarantee of winnings."
    },
    sv: {
      question: n => "Innan vi börjar: innehållet är avsett för personer som är " + n + "+. Är du " + n + " år eller äldre?",
      confirm: n => "Ja, jag är " + n + "+",
      decline: "Nej",
      blocked: n => "Du måste vara " + n + " år eller äldre för att använda tjänsten. Spela ansvarsfullt.",
      placeholder: "Bekräfta din ålder för att fortsätta…",
      responsible: "Spela ansvarsfullt — det finns ingen garanti för vinst."
    },
    de: {
      question: n => "Bevor wir loslegen: Diese Inhalte sind für Personen ab " + n + " Jahren bestimmt. Bist du " + n + " oder älter?",
      confirm: n => "Ja, ich bin " + n + "+",
      decline: "Nein",
      blocked: n => "Du musst " + n + " Jahre oder älter sein, um diesen Dienst zu nutzen. Spiele verantwortungsbewusst.",
      placeholder: "Bestätige dein Alter, um fortzufahren…",
      responsible: "Spiele verantwortungsbewusst — es gibt keine Gewinngarantie."
    },
    pt: {
      question: n => "Antes de começarmos: este conteúdo é destinado a maiores de " + n + " anos. Você tem " + n + " anos ou mais?",
      confirm: n => "Sim, tenho " + n + "+",
      decline: "Não",
      blocked: n => "Você precisa ter " + n + " anos ou mais para usar este serviço. Jogue com responsabilidade.",
      placeholder: "Confirme sua idade para continuar…",
      responsible: "Jogue com responsabilidade, não há garantia de ganhos."
    }
  };

  let _omActiveInstance = null;
  const _omInstances = new Set();
  class OddsMindChat extends HTMLElement {
    static get observedAttributes() {
      return ["widget-key", "language", "client-id", "bookmaker-id", "position", "api-url", "country", "z-index", "parent-origin", "footer-label", "footer-url", "footer-prefix", "footer-note", "title", "subtitle", "bottom-offset", "top-offset", "backdrop", "badge", "icon-url", "header-image-url", "launcher-image-url", "launcher-image-url-mobile", "welcome", "placeholder", "allow-fullscreen", "mode", "width", "height", "age-gate", "launcher-dismiss"];
    }
    constructor() {
      super();
      this._shadow = this.attachShadow({
        mode: "open"
      });
      this._shadow.innerHTML = "<style>".concat(STYLES, "</style>").concat(TEMPLATE);

      this._shadow.addEventListener("click", e => {
        const a = e.target && e.target.closest ? e.target.closest('a[data-cta="inline_odds"]') : null;
        if (!a) return;
        this._trackCtaClick({
          bookmakerName: a.getAttribute("data-bm") || "",
          betUrl: a.getAttribute("href") || "",
          label: a.getAttribute("data-label") || ""
        }, "inline_odds");
      });

      this._isOpen = false;
      this._isCollapsed = false;
      this._isFullscreen = false;
      this._isStreaming = false;
      this._conversationId = null;
      this._transcript = [];
      this._botMessageCount = 0;
      this._userHasMessaged = false;
      this._userMsgCount = 0;
      this._introChipsEl = null;
      this._sessionId = "oddsmind_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);

      this._ageConfirmed = false;
      this._ageGateShown = false;
      this._ageGatePending = false;
      this._ageMinAge = 18;

      this._currentChips = {
        pick3: null,
        pick4: null
      };
      this._fillerTimer = null;
      this._fillerIndex = 0;

      this._fab = this._shadow.querySelector(".om-fab");
      this._dismissBtn = this._shadow.querySelector(".om-dismiss");
      this._panel = this._shadow.querySelector(".om-panel");
      this._backdrop = this._shadow.querySelector(".om-backdrop");
      this._messages = this._shadow.querySelector(".om-messages");
      this._input = this._shadow.querySelector(".om-input");
      this._sendBtn = this._shadow.querySelector(".om-send");
      this._status = this._shadow.querySelector(".om-status");
      this._footerLink = this._shadow.querySelector(".om-footer a");
      this._footerNote = this._shadow.querySelector(".om-footer-note");
      this._footerRg = this._shadow.querySelector(".om-footer-rg");
      this._footerPrefix = this._shadow.querySelector(".om-footer-prefix");
      this._closeBtn = this._shadow.querySelector(".om-header-close");
      this._minBtn = this._shadow.querySelector(".om-header-min");
      this._fsBtn = this._shadow.querySelector(".om-header-fs");
      this._iconEl = this._shadow.querySelector(".om-header-icon");
      this._titleEl = this._shadow.querySelector(".om-header-text h3 .om-title");
      this._badgeEl = this._shadow.querySelector(".om-header-text .om-badge");
      this._subtitleEl = this._shadow.querySelector(".om-header-text p");
      this._ribbon = this._shadow.querySelector(".om-ribbon");
      this._ribbonIcon = this._shadow.querySelector(".om-ribbon-icon");
      this._headerImg = this._shadow.querySelector(".om-header-img");
      this._launcherImgsDesktop = this._shadow.querySelectorAll(".om-launcher-img--desktop");
      this._launcherImgsMobile = this._shadow.querySelectorAll(".om-launcher-img--mobile");
      this._ribbonTitle = this._shadow.querySelector(".om-ribbon-title");
      this._ribbonSubtitle = this._shadow.querySelector(".om-ribbon-subtitle");
      this._ribbonCtaLabel = this._shadow.querySelector(".om-ribbon-cta-label");

      this._scrollLockState = null;

      this._fab.addEventListener("click", () => this._toggle());
      this._dismissBtn.addEventListener("click", e => {
        e.stopPropagation();
        this._dismissLauncher();
      });
      this._closeBtn.addEventListener("click", () => {
        if (this._isInline()) this._setCollapsed(true);else this._setOpen(false);
      });
      this._ribbon.addEventListener("click", () => this._setCollapsed(false));
      this._minBtn.addEventListener("click", () => this.close());
      this._fsBtn.addEventListener("click", () => this._toggleFullscreen());
      this._backdrop.addEventListener("click", () => this._setOpen(false));
      this._sendBtn.addEventListener("click", () => this._sendMessage());
      this._input.addEventListener("keydown", e => {
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          this._sendMessage();
        }
      });
    }
    connectedCallback() {
      _omInstances.add(this);
      if (!this._isInline() && !this.hasAttribute("position")) {
        this.setAttribute("position", "bottom-right");
      }
      this._applyZIndex();
      this._applyBottomOffset();
      this._applyTopOffset();
      this._applySize();
      this._applyFont();
      this._applyFooter();
      this._applyHeader();
      this._applyPlaceholder();
      this._applyLauncherDismiss();
      const saved = this._loadPersistedConversation();
      const startedTs = saved && (typeof saved.startedTs === "number" ? saved.startedTs : saved.ts);
      const canResume = !!(saved && Array.isArray(saved.messages) && saved.messages.length && typeof startedTs === "number" && Date.now() - startedTs < CONV_PERSIST_TTL_MS);
      let resumed = false;
      if (canResume) {
        resumed = this._restoreConversation(saved);
      } else if (saved) {
        this._clearPersistedConversation();
      }
      if (!resumed) this._playIntro();
      this._initAgeGate();
      if (this._isInline()) {
        const remembered = this._loadUiState();
        const startCollapsed = remembered === "expanded" ? false : remembered === "collapsed" ? true : this.getAttribute("collapsed") !== "false";
        if (startCollapsed) this._setCollapsed(true);
      }
      if (_omActiveInstance && _omActiveInstance !== this) {
        this._suppress(true);
      } else if (this._isInline() && !this._isCollapsed) {
        this._notifyOpened();
      }
    }

    _isInline() {
      return (this.getAttribute("mode") || "").toLowerCase() === "inline";
    }

    _applyPlaceholder() {
      if (this._input && !this._input.disabled) {
        this._input.placeholder = this.getAttribute("placeholder") || this._uiText.ask;
      }
    }

    _applyFont() {
      const FONTS = {
        lance: "https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@300;400;500;600;700&display=swap"
      };
      const clientId = (this._clientId || "").toLowerCase();
      const href = FONTS[clientId];
      if (!href) return;
      const id = "om-font-" + clientId;
      if (document.getElementById(id)) return;
      const link = document.createElement("link");
      link.id = id;
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
    }

    _applyLauncherDismiss() {
      const raw = this.getAttribute("launcher-dismiss");
      const attr = raw === null ? null : raw.toLowerCase();
      const enabled = attr === "false" ? false : attr === "true" || attr === "" ? true : this._clientId.toLowerCase() === "lance";
      if (attr !== null && attr !== "" && attr !== "true" && attr !== "false") {
        console.warn("[oddsmind-chat] launcher-dismiss=\"" + raw + "\" is not a valid value — use \"true\" or \"false\". Falling back to the client default (" + (enabled ? "enabled" : "disabled") + ").");
      }
      this.classList.toggle("om-launcher-dismissible", enabled && !this._isInline());
      if (!enabled) this.restoreLauncher("attribute");
      if (this._dismissBtn) {
        this._dismissBtn.setAttribute("aria-label", this._uiText.hide || "Hide");
      }
    }

    _dismissLauncher() {
      this.classList.add("om-dismissed");
      this._emitLifecycle("oddsmind:launcher_dismissed", {
        trigger: "launcher"
      });
    }

    restoreLauncher(trigger) {
      if (!this.classList.contains("om-dismissed")) return;
      this.classList.remove("om-dismissed");
      this._emitLifecycle("oddsmind:launcher_restored", {
        trigger: trigger || "api"
      });
    }
    disconnectedCallback() {
      this._unlockBodyScroll();
      this._notifyClosed();
      _omInstances.delete(this);
    }
    attributeChangedCallback(name) {
      switch (name) {
        case "z-index":
          this._applyZIndex();
          break;
        case "bottom-offset":
          this._applyBottomOffset();
          break;
        case "top-offset":
        case "client-id":
          this._applyTopOffset();
          break;
        case "footer-label":
        case "footer-url":
        case "footer-prefix":
        case "footer-note":
          this._applyFooter();
          break;
        case "title":
        case "subtitle":
        case "badge":
        case "icon-url":
        case "allow-fullscreen":
          this._applyHeader();
          break;
        case "placeholder":
          this._applyPlaceholder();
          break;
        case "launcher-dismiss":
          this._applyLauncherDismiss();
          break;
        case "width":
        case "height":
          this._applySize();
          break;
      }
    }
    _applyZIndex() {
      const raw = this.getAttribute("z-index");
      const n = raw == null ? null : parseInt(raw, 10);
      if (n && Number.isFinite(n)) {
        this.style.setProperty("--om-z-index", String(n));
      } else {
        this.style.removeProperty("--om-z-index");
      }
    }

    _applyBottomOffset() {
      const raw = this.getAttribute("bottom-offset");
      const n = raw == null ? NaN : parseInt(raw, 10);
      if (Number.isFinite(n) && n >= 0) {
        this._warnImplausibleOffset("bottom-offset", n);
        this.style.setProperty("--om-bottom-offset", n + "px");
      } else {
        this.style.removeProperty("--om-bottom-offset");
      }
    }

    _warnImplausibleOffset(name, n) {
      if (n > 2000) {
        console.warn("[oddsmind-chat] " + name + "=\"" + n + "\" is larger than any plausible host chrome — the launcher/panel may sit entirely off-screen. Expected the pixel height of your fixed header/bottom bar (e.g. 64).");
      }
    }

    _applyTopOffset() {
      const raw = this.getAttribute("top-offset");
      const n = raw == null ? NaN : parseInt(raw, 10);
      const hasOffset = Number.isFinite(n) && n >= 0;
      if (hasOffset) {
        this._warnImplausibleOffset("top-offset", n);
        this.style.setProperty("--om-top-offset", n + "px");
      } else {
        this.style.removeProperty("--om-top-offset");
      }
      const anchored = hasOffset || this._clientId.toLowerCase() === "svenskaspel";
      this.classList.toggle("om-anchored", anchored);
    }

    _applySize() {
      const w = this._normalizeSize(this.getAttribute("width"));
      const h = this._normalizeSize(this.getAttribute("height"));
      if (w) this.style.setProperty("--om-panel-width", w);else this.style.removeProperty("--om-panel-width");
      if (h) this.style.setProperty("--om-panel-height", h);else this.style.removeProperty("--om-panel-height");
    }
    _normalizeSize(raw) {
      if (raw == null) return null;
      const v = String(raw).trim();
      if (!v) return null;
      if (/^\d+(\.\d+)?$/.test(v)) return v + "px"; 
      if (/^\d+(\.\d+)?(px|rem|em|vh|vw|vmin|vmax|%)$/.test(v)) return v;
      return null;
    }
    _applyFooter() {
      if (!this._footerLink) return;
      const label = this.getAttribute("footer-label") || "OddsMind";
      const rawUrl = this.getAttribute("footer-url") || "https://oddsmind.ai";
      const safeHref = this._safeUrl(rawUrl) || "https://oddsmind.ai";
      this._footerLink.textContent = label;
      this._footerLink.setAttribute("href", safeHref);

      if (this._footerPrefix) {
        const prefix = this.hasAttribute("footer-prefix") ? this.getAttribute("footer-prefix") : "Powered by ";
        this._footerPrefix.textContent = prefix;
        this._footerPrefix.style.display = prefix ? "" : "none";
      }

      if (this._footerNote) {
        const note = this.hasAttribute("footer-note") ? this.getAttribute("footer-note") : this._chipCopy && this._chipCopy.aiDisclaimer || "";
        this._footerNote.textContent = note;
        this._footerNote.style.display = note ? "" : "none";
      }
      if (this._footerRg) {
        const rg = this._chipCopy && this._chipCopy.responsible || "";
        this._footerRg.textContent = rg;
        this._footerRg.style.display = rg ? "" : "none";
      }
    }

    _applyHeader() {
      const title = this.getAttribute("title") || "OddsMind";
      const subtitle = this.getAttribute("subtitle") || "AI Betting Assistant";
      if (this._titleEl) this._titleEl.textContent = title;
      if (this._subtitleEl) this._subtitleEl.textContent = subtitle;
      if (this._ribbonTitle) this._ribbonTitle.textContent = title;
      if (this._ribbonSubtitle) this._ribbonSubtitle.textContent = subtitle;
      if (this._ribbonCtaLabel) {
        this._ribbonCtaLabel.textContent = this._uiText.open;
      }
      if (this._ribbon) {
        this._ribbon.setAttribute("aria-label", this._uiText.open + " — " + title);
      }
      if (this._badgeEl) {
        const badge = this.getAttribute("badge") || "";
        this._badgeEl.textContent = badge;
        this._badgeEl.hidden = !badge;
      }
      const rawIcon = this.getAttribute("icon-url");
      const iconUrl = rawIcon ? this._safeUrl(rawIcon) : null;
      if (iconUrl) {
        [this._iconEl, this._ribbonIcon].forEach(host => {
          if (!host) return;
          host.textContent = "";
          const img = document.createElement("img");
          img.src = iconUrl;
          img.alt = "";
          host.appendChild(img);
        });
      }
      this._applyBrandImage("launcher-image-url", this._launcherImgsDesktop, "om-has-launcher-img");
      this._applyBrandImage("launcher-image-url-mobile", this._launcherImgsMobile, "om-has-launcher-mobile");
      this._applyBrandImage("header-image-url", this._headerImg, "om-has-header-img");
      if (this._fsBtn) {
        this._fsBtn.hidden = !this.hasAttribute("allow-fullscreen");
      }
    }

    _toggleFullscreen() {
      this._isFullscreen = !this._isFullscreen;
      this._panel.classList.toggle("om-fullscreen", this._isFullscreen);
      if (this._fsBtn) {
        this._fsBtn.setAttribute("aria-label", this._isFullscreen ? "Exit fullscreen" : "Fullscreen");
      }
      if (this._isFullscreen) {
        this._lockBodyScroll();
      } else if (!(this._backdropMode() === "dim" && this._isOpen)) {
        this._unlockBodyScroll();
      }
    }

    _backdropMode() {
      return (this.getAttribute("backdrop") || "dim") === "none" ? "none" : "dim";
    }
    _lockBodyScroll() {
      if (this._scrollLockState) return;
      try {
        this._scrollLockState = {
          body: document.body.style.overflow,
          html: document.documentElement.style.overflow
        };
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";
      } catch (_) {
        this._scrollLockState = null;
      }
    }
    _unlockBodyScroll() {
      if (!this._scrollLockState) return;
      try {
        document.body.style.overflow = this._scrollLockState.body || "";
        document.documentElement.style.overflow = this._scrollLockState.html || "";
      } catch (_) {}
      this._scrollLockState = null;
    }

    get _lang() {
      return this.getAttribute("language") || "en";
    }
    get _apiBase() {
      return this.hasAttribute("api-url") ? this.getAttribute("api-url") : DEFAULT_API_BASE;
    }
    get _ctaLabels() {
      return this._localized(CTA_LABELS);
    }
    get _chipCopy() {
      return this._localized(CHIP_TEMPLATES);
    }
    get _uiText() {
      return this._localized(UI_TEXT);
    }
    get _thinkingMessages() {
      return this._localized(THINKING_MESSAGES);
    }
    get _ageText() {
      return this._localized(AGE_GATE_TEXT);
    }
    get _clientId() {
      return this.getAttribute("client-id") || "";
    }

    _localized(table) {
      const lang = this._lang;
      return table[lang] || table[lang.split("-")[0]] || table.en;
    }

    get _country() {
      const explicit = this.getAttribute("country");
      if (explicit) return explicit.toUpperCase();
      const fromLang = LANG_TO_COUNTRY[this._lang];
      if (fromLang) return fromLang;
      try {
        const raw = navigator.language || "";
        const region = raw.split("-")[1];
        if (region) return region.toUpperCase();
      } catch (e) {}
      return "GB";
    }

    open() {
      if (this._isInline()) this._setCollapsed(false);else this._setOpen(true);
    }
    close() {
      if (this._isInline()) this._setCollapsed(true);else this._setOpen(false);
    }
    toggle() {
      if (this._isInline()) this._setCollapsed(!this._isCollapsed);else this._toggle();
    }

    _toggle() {
      this._setOpen(!this._isOpen);
    }

    _setCollapsed(collapsed) {
      if (!this._isInline()) return;
      const wasCollapsed = this._isCollapsed;
      this._isCollapsed = collapsed;
      this.classList.toggle("om-collapsed", collapsed);
      this._saveUiState(collapsed ? "collapsed" : "expanded");
      if (!collapsed) {
        if (wasCollapsed) this._emitLifecycle("oddsmind:widget_opened", {
          trigger: "ribbon"
        });
        try {
          this._input.focus();
        } catch (_) {}
        this._notifyOpened();
      } else {
        this._notifyClosed();
      }
    }
    _setOpen(open) {
      const wasOpen = this._isOpen;
      this._isOpen = open;
      this._fab.classList.toggle("open", open);
      this.classList.toggle("om-open", open);
      this._panel.classList.toggle("open", open);
      this._backdrop.classList.toggle("open", open);
      if (open) {
        if (!wasOpen) this._emitLifecycle("oddsmind:widget_opened", {
          trigger: "panel"
        });
        if (this._backdropMode() === "dim") this._lockBodyScroll();
        this._input.focus();
        this._notifyOpened();
      } else {
        this._unlockBodyScroll();
        this._notifyClosed();
      }
    }

    _notifyOpened() {
      _omActiveInstance = this;
      _omInstances.forEach(inst => {
        if (inst !== this) inst._suppress(true);
      });
    }

    _notifyClosed() {
      if (_omActiveInstance !== this) return;
      _omActiveInstance = null;
      _omInstances.forEach(inst => {
        if (inst !== this) inst._suppress(false);
      });
    }

    _suppress(suppress) {
      if (suppress) {
        if (this._isInline()) {
          this._isCollapsed = true;
          this.classList.add("om-collapsed");
        } else if (this._isOpen) {
          this._isOpen = false;
          this._fab.classList.remove("open");
          this._panel.classList.remove("open");
          this._backdrop.classList.remove("open");
          this._unlockBodyScroll();
        }
      }
      this.classList.toggle("om-suppressed", suppress);
    }

    _playIntro() {
      const copy = this._chipCopy;
      this._addBotMessage(this.getAttribute("welcome") || copy && copy.welcome || "Hi! I\u2019m OddsMind \u2014 your AI betting assistant. Ask me about any match, team or player and I\u2019ll find value for you.");
      this._renderIntroChips();
      this._upgradeChipsFromTips();
    }

    _convStorageKey() {
      return "oddsmind_conv_" + (this._clientId || this.getAttribute("widget-key") || "default");
    }
    _loadPersistedConversation() {
      try {
        const raw = localStorage.getItem(this._convStorageKey());
        if (!raw) return null;
        const data = JSON.parse(raw);
        if (!data || data.v !== CONV_PERSIST_VERSION) return null;
        return data;
      } catch (_) {
        return null;
      }
    }
    _persistConversation() {
      if (!this._transcript.length) return;
      try {
        const existing = this._loadPersistedConversation();
        const startedTs = existing && typeof existing.startedTs === "number" ? existing.startedTs : Date.now();
        localStorage.setItem(this._convStorageKey(), JSON.stringify({
          v: CONV_PERSIST_VERSION,
          startedTs,
          ts: Date.now(),
          conversationId: this._conversationId || null,
          sessionId: this._sessionId,
          messages: this._transcript.slice(-CONV_PERSIST_MAX_MSGS)
        }));
      } catch (_) {}
    }
    _clearPersistedConversation() {
      try {
        localStorage.removeItem(this._convStorageKey());
      } catch (_) {}
    }

    _uiStateKey() {
      return "oddsmind_ui_" + (this._clientId || this.getAttribute("widget-key") || "default");
    }
    _loadUiState() {
      try {
        return sessionStorage.getItem(this._uiStateKey());
      } catch (_) {
        return null;
      }
    }
    _saveUiState(state) {
      try {
        sessionStorage.setItem(this._uiStateKey(), state);
      } catch (_) {}
    }

    _restoreConversation(saved) {
      if (!saved || !Array.isArray(saved.messages) || !saved.messages.length) return false;
      this._conversationId = saved.conversationId || null;
      if (saved.sessionId) this._sessionId = saved.sessionId;
      let botCount = 0;
      for (const m of saved.messages) {
        if (!m) continue;
        if (m.role === "user") {
          this._addUserMessage(m.text || "");
        } else if (m.role === "bot") {
          this._renderRestoredBotMessage(m);
          botCount++;
        }
      }
      this._transcript = saved.messages.slice();
      this._botMessageCount = botCount;
      this._userHasMessaged = true;
      this._scrollToBottom();
      return true;
    }
    _renderRestoredBotMessage(m) {
      const msg = document.createElement("div");
      msg.className = "om-msg bot";
      const textEl = document.createElement("div");
      if (m.html) textEl.innerHTML = DOMPurify.sanitize(m.html, SANITIZE_CONFIG);
      const widgetsEl = document.createElement("div");
      widgetsEl.className = "widgets-container";
      if (m.widgets) widgetsEl.innerHTML = DOMPurify.sanitize(m.widgets, SANITIZE_CONFIG);
      msg.appendChild(textEl);
      msg.appendChild(widgetsEl);
      this._messages.appendChild(msg);
      return msg;
    }

    resetConversation() {
      this._clearPersistedConversation();
      this._conversationId = null;
      this._sessionId = "oddsmind_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8);
      this._transcript = [];
      this._botMessageCount = 0;
      this._userHasMessaged = false;
      this._messages.innerHTML = "";
      this._playIntro();
      this._emitLifecycle("oddsmind:conversation_reset");
    }

    _ageGateAttr() {
      const raw = this.getAttribute("age-gate");
      if (raw == null) return null;
      const n = parseInt(raw, 10);
      return Number.isFinite(n) && n >= 1 ? n : null;
    }
    _ageStorageKey() {
      return "oddsmind_age_confirmed_" + (this._clientId || "default");
    }
    _ageAlreadyConfirmed() {
      try {
        return !!localStorage.getItem(this._ageStorageKey());
      } catch (_) {
        return false;
      }
    }
    async _initAgeGate() {
      if (this._ageConfirmed || this._ageAlreadyConfirmed()) {
        this._ageConfirmed = true;
        return;
      }
      const attrAge = this._ageGateAttr();
      if (attrAge != null) {
        this._enforceAgeGate(attrAge);
        return;
      }
      const widgetKey = this.getAttribute("widget-key");
      const clientId = this._clientId;
      if (!widgetKey || !clientId) return;
      try {
        const resp = await fetch(this._apiBase + "/api/public/client-config?clientId=" + encodeURIComponent(clientId), {
          headers: {
            "X-Widget-Key": widgetKey
          }
        });
        if (!resp.ok) return;
        const cfg = await resp.json();
        if (cfg && cfg.ageGate && cfg.ageGate.enabled) {
          this._enforceAgeGate(cfg.ageGate.minAge >= 1 ? cfg.ageGate.minAge : 18);
        }
      } catch (_) {}
    }
    _enforceAgeGate(minAge) {
      if (this._ageConfirmed || this._ageGateShown) return;
      this._ageGateShown = true;
      this._ageGatePending = true;
      this._ageMinAge = minAge;
      const t = this._ageText;

      if (this._input) {
        this._input.disabled = true;
        this._input.placeholder = t.placeholder;
      }
      if (this._sendBtn) this._sendBtn.disabled = true;
      if (this._introChipsEl) {
        this._introChipsEl.remove();
        this._introChipsEl = null;
      }

      const bubble = this._addBotMessage("");
      const q = document.createElement("div");
      q.textContent = t.question(minAge);
      const btns = document.createElement("div");
      btns.className = "om-age-btns";
      const yes = document.createElement("button");
      yes.type = "button";
      yes.className = "om-age-btn yes";
      yes.textContent = t.confirm(minAge);
      const no = document.createElement("button");
      no.type = "button";
      no.className = "om-age-btn no";
      no.textContent = t.decline;
      yes.addEventListener("click", () => {
        if (this._ageConfirmed) return;
        this._ageConfirmed = true;
        this._ageGatePending = false;
        try {
          localStorage.setItem(this._ageStorageKey(), new Date().toISOString());
        } catch (_) {}
        this._storeAgeConfirmation();
        btns.remove();
        if (t.responsible) {
          const note = document.createElement("div");
          note.className = "om-age-note";
          note.textContent = t.responsible;
          bubble.appendChild(note);
        }
        if (this._input) {
          this._input.disabled = false;
          this._input.placeholder = this._uiText.ask;
        }
        if (this._sendBtn) this._sendBtn.disabled = false;
        if (!this._userHasMessaged) this._renderIntroChips();
        if (this._input) this._input.focus();
      });
      no.addEventListener("click", () => {
        yes.disabled = true;
        no.disabled = true;
        const blocked = document.createElement("div");
        blocked.className = "om-age-blocked";
        blocked.textContent = t.blocked(minAge);
        bubble.appendChild(blocked);
      });
      btns.appendChild(yes);
      btns.appendChild(no);
      bubble.appendChild(q);
      bubble.appendChild(btns);
      this._scrollToBottom();
    }

    _storeAgeConfirmation() {
      const widgetKey = this.getAttribute("widget-key");
      if (!widgetKey || !this._clientId) return;
      try {
        fetch(this._apiBase + "/api/public/age-confirmation", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Widget-Key": widgetKey
          },
          body: JSON.stringify({
            clientId: this._clientId,
            sessionId: this._sessionId,
            conversationId: this._conversationId || undefined,
            minAge: this._ageMinAge
          })
        }).catch(() => {});
      } catch (_) {}
    }
    _renderIntroChips() {
      if (this._ageGatePending && !this._ageConfirmed) return;
      const copy = this._chipCopy;
      const country = this._country;
      const homeTeam = COUNTRY_TO_TEAM[country] || null;
      const texts = [copy.tip, copy.acca];

      if (this._currentChips.pick3) {
        const p = this._currentChips.pick3;
        texts.push(copy.generic(p.home, p.away));
      } else if (homeTeam) {
        texts.push(copy.team(homeTeam));
      } else {
        texts.push(copy.fallback);
      }

      if (this._currentChips.pick4) {
        const p = this._currentChips.pick4;
        texts.push(copy.generic(p.home, p.away));
      } else {
        texts.push(copy.fallback);
      }
      const row = document.createElement("div");
      row.className = "om-intro-chips";
      texts.forEach(text => {
        const chip = document.createElement("button");
        chip.className = "om-intro-chip";
        chip.type = "button";
        chip.textContent = text;
        chip.addEventListener("click", () => {
          if (this._isStreaming) return;
          this._input.value = text;
          if (this._introChipsEl) {
            this._introChipsEl.remove();
            this._introChipsEl = null;
          }
          this._sendMessage();
        });
        row.appendChild(chip);
      });
      if (this._introChipsEl && this._introChipsEl.parentNode) {
        this._introChipsEl.parentNode.replaceChild(row, this._introChipsEl);
      } else {
        this._messages.appendChild(row);
      }
      this._introChipsEl = row;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          row.style.opacity = "1";
        });
      });
    }
    async _upgradeChipsFromTips() {
      if (this._userHasMessaged) return;
      const country = this._country;
      const widgetKey = this.getAttribute("widget-key");
      if (!widgetKey) return; 
      try {
        const resp = await fetch(this._apiBase + "/api/public/tips?limit=10&country=" + encodeURIComponent(country) + "&lang=" + encodeURIComponent(this._lang), {
          headers: {
            "X-Widget-Key": widgetKey
          }
        });
        if (!resp.ok) return;
        const data = await resp.json();
        const tips = data && data.tips || [];
        if (!Array.isArray(tips) || tips.length === 0) return;
        const todayIso = new Date().toISOString().slice(0, 10);
        const seen = new Set();
        const matches = [];
        for (const tip of tips) {
          const home = tip.homeTeam;
          const away = tip.awayTeam;
          if (!home || !away) continue;
          const key = home + "|" + away;
          if (seen.has(key)) continue;
          seen.add(key);
          matches.push({
            home,
            away,
            homeRaw: tip.homeTeamRaw || home,
            awayRaw: tip.awayTeamRaw || away,
            date: tip.matchDate,
            matchId: tip.matchId
          });
        }
        if (matches.length === 0) return;

        const homeTeam = COUNTRY_TO_TEAM[country] || null;
        const teamMatch = homeTeam ? matches.find(m => m.homeRaw.toLowerCase().includes(homeTeam.toLowerCase()) || m.awayRaw.toLowerCase().includes(homeTeam.toLowerCase())) : null;
        const todayMatch = matches.find(m => m.date === todayIso);
        const pick3 = teamMatch || todayMatch || matches[0];

        const pick4 = matches.find(m => m !== pick3 && m.home + "|" + m.away !== pick3.home + "|" + pick3.away) || null;
        this._currentChips = {
          pick3,
          pick4
        };
        if (!this._userHasMessaged) this._renderIntroChips();

        const warmIds = [pick3.matchId, pick4 && pick4.matchId].filter(Boolean);
        if (warmIds.length > 0) {
          const clientId = this.getAttribute("client-id") || undefined;
          const bookmakerIdAttr = this.getAttribute("bookmaker-id");
          const bookmakerId = bookmakerIdAttr ? Number(bookmakerIdAttr) : undefined;
          fetch(this._apiBase + "/api/public/warm-recommendations", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Widget-Key": widgetKey
            },
            body: JSON.stringify({
              matchIds: warmIds,
              lang: this._lang,
              clientId,
              bookmakerId
            })
          }).catch(() => {});
        }
      } catch (e) {
      }
    }

    _addUserMessage(text) {
      const msg = document.createElement("div");
      msg.className = "om-msg user";
      msg.textContent = text;
      this._messages.appendChild(msg);
      this._scrollToBottom();
    }
    _addBotMessage(html) {
      const msg = document.createElement("div");
      msg.className = "om-msg bot";
      msg.innerHTML = html;
      this._messages.appendChild(msg);
      this._scrollToBottom();
      return msg;
    }
    _scrollToBottom() {
      this._messages.scrollTop = this._messages.scrollHeight;
    }
    _setStatus(text, opts) {
      const fromFiller = !!(opts && opts.fromFiller);
      if (!text) {
        this._status.textContent = "";
        this._stopFillerMessages();
        return;
      }

      let textEl = this._status.querySelector(".om-status-text");
      let dotsEl = this._status.querySelector(".om-status-dots");
      if (!textEl) {
        this._status.textContent = "";
        textEl = document.createElement("span");
        textEl.className = "om-status-text";
        dotsEl = document.createElement("span");
        dotsEl.className = "om-status-dots";
        dotsEl.innerHTML = "<span></span><span></span><span></span>";
        this._status.appendChild(textEl);
        this._status.appendChild(dotsEl);
      }
      if (textEl.textContent !== text) {
        if (fromFiller) {
          this._status.classList.add("swapping");
          setTimeout(() => {
            textEl.textContent = text;
            this._status.classList.remove("swapping");
          }, 120);
        } else {
          textEl.textContent = text;
        }
      }

      if (!fromFiller) this._startFillerMessages();
    }

    _startFillerMessages() {
      this._stopFillerMessages();
      this._fillerTimer = setInterval(() => {
        const list = this._chipCopy && this._chipCopy.fillers || [];
        if (list.length === 0) return;
        const msg = list[this._fillerIndex % list.length];
        this._fillerIndex += 1;
        this._setStatus(msg, {
          fromFiller: true
        });
      }, 3500);
    }
    _stopFillerMessages() {
      if (this._fillerTimer) {
        clearInterval(this._fillerTimer);
        this._fillerTimer = null;
      }
      this._fillerIndex = 0;
    }

    _getOrCreateActions(botMsg) {
      const existingId = botMsg.dataset.actionsId;
      if (existingId) {
        const el = this._shadow.getElementById(existingId);
        if (el) return el;
      }
      const container = document.createElement("div");
      const id = "om_act_" + Date.now() + "_" + Math.random().toString(36).slice(2, 6);
      container.id = id;
      container.className = "om-actions";
      botMsg.dataset.actionsId = id;
      botMsg.insertAdjacentElement("afterend", container);
      return container;
    }

    async _sendMessage() {
      if (this._ageGatePending && !this._ageConfirmed) return;
      const text = this._input.value.trim();
      if (!text || this._isStreaming) return;
      this._userHasMessaged = true;
      this._userMsgCount += 1;
      this._emitLifecycle("oddsmind:message_sent", {
        messageNumber: this._userMsgCount
      });
      if (this._introChipsEl) {
        this._introChipsEl.remove();
        this._introChipsEl = null;
      }
      this._isStreaming = true;
      this._input.value = "";
      this._input.disabled = true;
      this._sendBtn.disabled = true;
      this._input.placeholder = this._uiText.waiting;
      this._addUserMessage(text);

      const botMsg = document.createElement("div");
      botMsg.className = "om-msg bot";
      const botTextEl = document.createElement("div");
      const botWidgetsEl = document.createElement("div");
      botWidgetsEl.className = "widgets-container";
      botMsg.appendChild(botTextEl);
      botMsg.appendChild(botWidgetsEl);
      this._messages.appendChild(botMsg);
      this._scrollToBottom();
      const currentBotIndex = this._botMessageCount;
      this._botMessageCount++;
      let fullText = "";
      const pendingMetaBets = [];
      const applyInlineLinks = () => {
        for (const data of pendingMetaBets) {
          var _data$bookmaker, _data$match, _data$match2;
          this._linkOddsInline(botMsg, {
            oddsDecimal: data.odds.decimal,
            betUrl: data.deeplink,
            bookmakerName: ((_data$bookmaker = data.bookmaker) === null || _data$bookmaker === void 0 ? void 0 : _data$bookmaker.name) || "bookmaker",
            label: "".concat(data.selection, " \u2014 ").concat((_data$match = data.match) === null || _data$match === void 0 ? void 0 : _data$match.homeTeam, " vs ").concat((_data$match2 = data.match) === null || _data$match2 === void 0 ? void 0 : _data$match2.awayTeam)
          }, data);
        }
      };

      const thinkingMsgs = this._thinkingMessages;
      const randomThinking = () => thinkingMsgs[Math.floor(Math.random() * thinkingMsgs.length)];
      botTextEl.innerHTML = "<em>" + randomThinking() + "</em>";
      const thinkingInterval = setInterval(() => {
        botTextEl.innerHTML = "<em>" + randomThinking() + "</em>";
        this._scrollToBottom();
      }, 2500);
      try {
        const body = {
          message: text,
          language: this._lang,
          sessionId: this._sessionId
        };
        const clientId = this.getAttribute("client-id");
        if (clientId) body.clientId = clientId;
        const bookmakerId = this.getAttribute("bookmaker-id");
        if (bookmakerId) body.bookmakerId = parseInt(bookmakerId, 10);
        if (this._conversationId) body.conversationId = this._conversationId;
        try {
          const off = -new Date().getTimezoneOffset();
          const sign = off >= 0 ? "+" : "-";
          const abs = Math.abs(off);
          const h = Math.floor(abs / 60),
            m = abs % 60;
          body.timezone = m === 0 ? "UTC".concat(sign).concat(h) : "UTC".concat(sign).concat(h, ":").concat(String(m).padStart(2, "0"));
        } catch (_) {}
        const widgetKey = this.getAttribute("widget-key");
        if (!widgetKey) {
          botTextEl.innerHTML = "<em>Error: missing widget-key attribute.</em>";
          return;
        }
        const response = await fetch(this._apiBase + "/api/public/chat/stream", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Widget-Key": widgetKey
          },
          body: JSON.stringify(body)
        });
        if (!response.ok) throw new Error("API returned " + response.status);
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let buffer = "";
        while (true) {
          const {
            done,
            value
          } = await reader.read();
          if (done) break;
          buffer += decoder.decode(value, {
            stream: true
          });
          const lines = buffer.split("\n");
          buffer = lines.pop();
          for (const line of lines) {
            if (!line.startsWith("data: ")) continue;
            const payload = line.slice(6).trim();
            if (payload === "[DONE]") continue;
            try {
              const event = JSON.parse(payload);
              if (event.conversationId && !this._conversationId) {
                this._conversationId = event.conversationId;
                this._emitLifecycle("oddsmind:conversation_started");
              }
              switch (event.type) {
                case "status":
                  botTextEl.innerHTML = "<em>" + (event.message || "Processing\u2026") + "</em>";
                  break;
                case "tool_start":
                  botTextEl.innerHTML = "<em>" + (event.message || "Fetching data\u2026") + "</em>";
                  break;
                case "tool_end":
                  botTextEl.innerHTML = "<em>Analysing\u2026</em>";
                  break;
                case "content":
                  if (event.content) {
                    clearInterval(thinkingInterval);
                    fullText += event.content;
                    botTextEl.innerHTML = this._formatMarkdown(fullText);
                    this._scrollToBottom();
                  }
                  break;
                case "message_commit":
                  if (event.cleanedContent) {
                    clearInterval(thinkingInterval);
                    fullText = event.cleanedContent;
                    botTextEl.innerHTML = this._formatMarkdown(fullText);
                    applyInlineLinks();
                    this._scrollToBottom();
                  }
                  break;
                case "html_display":
                  if (event.content || event.html) {
                    const rawHtml = event.content || event.html;
                    const block = document.createElement("div");
                    block.style.marginTop = "8px";
                    botWidgetsEl.appendChild(block);
                    block.innerHTML = DOMPurify.sanitize(rawHtml, SANITIZE_CONFIG);
                    this._scrollToBottom();
                  }
                  break;
                case "follow_up_suggestions":
                  this._renderFollowUpChips(botMsg, event.suggestions);
                  break;
                case "meta_bet":
                  if (event.data && event.data.deeplink && event.data.odds) {
                    pendingMetaBets.push(event.data);
                    this._stashMetaBet(botMsg, event.data);
                    requestAnimationFrame(applyInlineLinks);
                  }
                  break;
                case "bookmaker_cta":
                  this._handleBookmakerCta(botMsg, event);
                  break;
                case "widget_instruction":
                  {
                    this.dispatchEvent(new CustomEvent("widget_instruction", {
                      detail: event,
                      bubbles: true,
                      composed: true
                    }));

                    if (window.parent !== window) {
                      const targetOrigin = this.getAttribute("parent-origin");
                      if (targetOrigin) {
                        try {
                          const parsed = new URL(targetOrigin);
                          window.parent.postMessage({
                            type: "widget_instruction",
                            data: event
                          }, parsed.origin);
                        } catch (_) {}
                      }
                    }
                    break;
                  }
              }
            } catch (_) {}
          }
        }
        if (!fullText && botTextEl.innerHTML === "" && botWidgetsEl.childElementCount === 0) {
          botTextEl.innerHTML = "<em>No response received. Try again.</em>";
        }
      } catch (err) {
        botTextEl.innerHTML = "<em>Something went wrong. Please try again.</em>";
        console.error("[oddsmind-chat] Stream error:", err);
      } finally {
        clearInterval(thinkingInterval);
        this._isStreaming = false;
        this._setStatus("");
        this._input.disabled = false;
        this._sendBtn.disabled = false;
        this._input.placeholder = this._uiText.ask;
        this._input.focus();

        if (this._conversationId && (fullText || botWidgetsEl.childElementCount > 0)) {
          this._renderFeedbackButtons(botMsg, currentBotIndex);
        }

        if (fullText || botWidgetsEl.childElementCount > 0) {
          this._transcript.push({
            role: "user",
            text
          });
          this._transcript.push({
            role: "bot",
            html: botTextEl.innerHTML,
            widgets: botWidgetsEl.innerHTML || ""
          });
          this._persistConversation();
        }
      }
    }

    _renderFollowUpChips(botMsg, suggestions) {
      if (!Array.isArray(suggestions) || suggestions.length === 0) return;
      const cleaned = [...new Set(suggestions.map(s => String(s || "").replace(/\s+/g, " ").trim()).filter(Boolean))].slice(0, 3);
      if (!cleaned.length) return;
      const actions = this._getOrCreateActions(botMsg);
      const existing = actions.querySelector(".om-chips");
      if (existing) existing.remove();
      const row = document.createElement("div");
      row.className = "om-chips";
      cleaned.forEach(q => {
        const chip = document.createElement("button");
        chip.className = "om-chip";
        chip.type = "button";
        chip.textContent = q;
        chip.addEventListener("click", () => {
          if (this._isStreaming) return;
          this._input.value = q;
          this._sendMessage();
        });
        row.appendChild(chip);
      });
      actions.appendChild(row);
      this._scrollToBottom();
    }

    _renderFeedbackButtons(botMsg, messageIndex) {
      const actions = this._getOrCreateActions(botMsg);
      if (actions.querySelector(".om-feedback-row")) return;
      const row = document.createElement("div");
      row.className = "om-feedback-row";
      const makeBtn = (rating, label, symbol) => {
        const btn = document.createElement("button");
        btn.className = "om-feedback-btn";
        btn.type = "button";
        btn.title = label;
        btn.setAttribute("aria-label", label);
        btn.textContent = symbol;
        btn.addEventListener("click", () => this._submitFeedback(actions, row, messageIndex, rating));
        return btn;
      };
      row.appendChild(makeBtn("up", "Helpful", "\uD83D\uDC4D"));
      row.appendChild(makeBtn("down", "Not helpful", "\uD83D\uDC4E"));
      actions.appendChild(row);
    }
    _submitFeedback(actions, row, messageIndex, rating) {
      if (!this._conversationId) return;
      const buttons = Array.from(row.querySelectorAll(".om-feedback-btn"));
      buttons.forEach(b => {
        b.disabled = true;
        b.classList.remove("active-up", "active-down");
      });
      const idx = rating === "up" ? 0 : 1;
      buttons[idx].classList.add(rating === "up" ? "active-up" : "active-down");
      const widgetKey = this.getAttribute("widget-key");
      fetch(this._apiBase + "/api/public/message-feedback", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Widget-Key": widgetKey
        },
        body: JSON.stringify({
          conversationId: this._conversationId,
          messageIndex,
          rating
        })
      }).then(resp => {
        if (!resp.ok) {
          buttons.forEach(b => {
            b.disabled = false;
          });
          buttons[idx].classList.remove("active-up", "active-down");
          return;
        }
        if (rating === "down") {
          this._renderFeedbackComment(actions, messageIndex);
        }
      }).catch(() => {
        buttons.forEach(b => {
          b.disabled = false;
        });
        buttons[idx].classList.remove("active-up", "active-down");
      });
    }
    _renderFeedbackComment(actions, messageIndex) {
      if (actions.querySelector(".om-feedback-comment")) return;
      const wrap = document.createElement("div");
      wrap.className = "om-feedback-comment";
      const textarea = document.createElement("textarea");
      textarea.placeholder = "What was wrong?";
      textarea.maxLength = 2000;
      textarea.rows = 2;
      const btnRow = document.createElement("div");
      btnRow.className = "om-feedback-comment-row";
      const send = document.createElement("button");
      send.type = "button";
      send.className = "om-feedback-comment-send";
      send.textContent = "Send";
      const skip = document.createElement("button");
      skip.type = "button";
      skip.className = "om-feedback-comment-skip";
      skip.textContent = "Skip";
      const showThanks = () => {
        wrap.innerHTML = "";
        const thanks = document.createElement("span");
        thanks.className = "om-feedback-comment-thanks";
        thanks.textContent = "Thanks for your feedback!";
        wrap.appendChild(thanks);
        setTimeout(() => wrap.remove(), 2500);
      };
      const submit = async () => {
        const text = textarea.value.trim();
        if (!text) {
          wrap.remove();
          return;
        }
        send.disabled = true;
        skip.disabled = true;
        try {
          const widgetKey = this.getAttribute("widget-key");
          const resp = await fetch(this._apiBase + "/api/public/message-feedback", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Widget-Key": widgetKey
            },
            body: JSON.stringify({
              conversationId: this._conversationId,
              messageIndex,
              rating: "down",
              comment: text
            })
          });
          if (!resp.ok) throw new Error("HTTP " + resp.status);
          showThanks();
        } catch (err) {
          console.error("[oddsmind-chat] Feedback comment failed:", err);
          send.disabled = false;
          skip.disabled = false;
        }
      };
      send.addEventListener("click", submit);
      skip.addEventListener("click", () => wrap.remove());
      textarea.addEventListener("keydown", e => {
        if (e.key === "Enter" && (e.metaKey || e.ctrlKey)) {
          e.preventDefault();
          submit();
        }
      });
      btnRow.appendChild(send);
      btnRow.appendChild(skip);
      wrap.appendChild(textarea);
      wrap.appendChild(btnRow);
      actions.appendChild(wrap);
      textarea.focus();
    }

    _isInterceptEnabled() {
      return this.getAttribute("bookmaker-id") === "32" && this.getAttribute("client-id") === "svenskaspel";
    }
    _stashMetaBet(botMsg, data) {
      var _data$odds$decimal, _data$odds, _data$odds2, _data$match3, _data$outright, _data$outright2, _data$match4, _data$match5, _data$outright3, _data$match6, _data$bookmaker$id, _data$bookmaker2, _data$bookmaker3;
      if (!botMsg || !data) return;
      const normalized = {
        outcomeId: data.betId,
        matchId: data.matchId,
        selection: data.selection || null,
        marketDescription: data.marketDescription || null,
        oddsDecimal: (_data$odds$decimal = (_data$odds = data.odds) === null || _data$odds === void 0 ? void 0 : _data$odds.decimal) !== null && _data$odds$decimal !== void 0 ? _data$odds$decimal : null,
        oddsFractional: ((_data$odds2 = data.odds) === null || _data$odds2 === void 0 ? void 0 : _data$odds2.fractional) || null,
        homeTeam: ((_data$match3 = data.match) === null || _data$match3 === void 0 ? void 0 : _data$match3.homeTeam) || ((_data$outright = data.outright) === null || _data$outright === void 0 ? void 0 : _data$outright.entityTeam) || ((_data$outright2 = data.outright) === null || _data$outright2 === void 0 ? void 0 : _data$outright2.entityName) || null,
        awayTeam: ((_data$match4 = data.match) === null || _data$match4 === void 0 ? void 0 : _data$match4.awayTeam) || null,
        competition: ((_data$match5 = data.match) === null || _data$match5 === void 0 ? void 0 : _data$match5.competition) || ((_data$outright3 = data.outright) === null || _data$outright3 === void 0 ? void 0 : _data$outright3.competitionName) || null,
        matchDate: ((_data$match6 = data.match) === null || _data$match6 === void 0 ? void 0 : _data$match6.date) || null,
        bookmakerId: (_data$bookmaker$id = (_data$bookmaker2 = data.bookmaker) === null || _data$bookmaker2 === void 0 ? void 0 : _data$bookmaker2.id) !== null && _data$bookmaker$id !== void 0 ? _data$bookmaker$id : null,
        bookmakerName: ((_data$bookmaker3 = data.bookmaker) === null || _data$bookmaker3 === void 0 ? void 0 : _data$bookmaker3.name) || null,
        deeplink: data.deeplink || null
      };
      try {
        const existing = botMsg.dataset.metaBets ? JSON.parse(botMsg.dataset.metaBets) : [];
        const key = "".concat(normalized.matchId, ":").concat(normalized.outcomeId);
        if (existing.some(b => "".concat(b.matchId, ":").concat(b.outcomeId) === key)) return;
        existing.push(normalized);
        botMsg.dataset.metaBets = JSON.stringify(existing);
      } catch (_) {}
    }
    _collectBetsFromMessage(botMsg) {
      if (!botMsg || !botMsg.dataset.metaBets) return [];
      try {
        return JSON.parse(botMsg.dataset.metaBets) || [];
      } catch (_) {
        return [];
      }
    }

    _dispatchBetIntercept(source, bets, fallbackUrl) {
      if (!Array.isArray(bets) || bets.length === 0) return false;
      const first = bets[0];
      const detail = {
        source,
        bookmaker: {
          id: first.bookmakerId,
          name: first.bookmakerName || "bookmaker"
        },
        coupon: {
          type: bets.length > 1 ? "combination" : "single",
          outcomeIds: bets.map(b => b.outcomeId).filter(id => id != null)
        },
        bets: bets.map(b => ({
          outcomeId: b.outcomeId,
          selection: b.selection,
          marketDescription: b.marketDescription,
          odds: {
            decimal: b.oddsDecimal,
            fractional: b.oddsFractional
          },
          homeTeam: b.homeTeam,
          awayTeam: b.awayTeam,
          competition: b.competition,
          matchDate: b.matchDate
        })),
        fallbackUrl: fallbackUrl || first.deeplink || null
      };
      this.dispatchEvent(new CustomEvent("bet_intercept", {
        detail,
        bubbles: true,
        composed: true,
        cancelable: true
      }));
      if (window.parent !== window) {
        const targetOrigin = this.getAttribute("parent-origin");
        if (targetOrigin) {
          try {
            const parsed = new URL(targetOrigin);
            window.parent.postMessage({
              type: "bet_intercept",
              data: detail
            }, parsed.origin);
          } catch (_) {}
        }
      }
      return true;
    }

    _emitLifecycle(type, extra) {
      const detail = _objectSpread({
        type,
        sessionId: this._sessionId,
        conversationId: this._conversationId || null,
        clientId: this.getAttribute("client-id") || null,
        language: this._lang
      }, extra || {});
      this.dispatchEvent(new CustomEvent(type, {
        detail,
        bubbles: true,
        composed: true
      }));
      if (window.parent !== window) {
        const targetOrigin = this.getAttribute("parent-origin");
        if (targetOrigin) {
          try {
            const parsed = new URL(targetOrigin);
            window.parent.postMessage({
              type,
              data: detail
            }, parsed.origin);
          } catch (_) {}
        }
      }
    }

    _handleBookmakerCta(botMsg, event) {
      if (!botMsg || !event || !event.betUrl) return;
      const cta = {
        bookmakerName: event.bookmakerName || "svenskaspel",
        betUrl: String(event.betUrl),
        label: String(event.label || "Place a bet now")
      };
      const existing = botMsg.dataset.betCtas ? JSON.parse(botMsg.dataset.betCtas) : [];
      const key = cta.label + "|" + cta.betUrl;
      if (existing.some(item => item.label + "|" + item.betUrl === key)) return;
      if (existing.length >= 4) return;
      existing.push(cta);
      botMsg.dataset.betCtas = JSON.stringify(existing);
      this._renderBetCtas(botMsg, existing);
      this._scrollToBottom();
    }

    _findBotTextEl(botMsg) {
      if (!botMsg) return null;
      for (const kid of botMsg.children) {
        if (kid.classList.contains("widgets-container")) continue;
        if (kid.classList.contains("om-chat-status-inline")) continue;
        return kid;
      }
      return null;
    }

    _linkOddsInline(botMsg, event, originalMetaBet) {
      if (!event || !event.betUrl || event.oddsDecimal == null) return;
      const textEl = this._findBotTextEl(botMsg);
      if (!textEl) return;
      const odds = Number(event.oddsDecimal);
      if (!Number.isFinite(odds)) return;
      const candidates = [odds.toFixed(2), odds.toFixed(1), String(odds)];
      const seen = new Set();
      const uniqueCandidates = candidates.filter(c => seen.has(c) ? false : (seen.add(c), true));
      for (const candidate of uniqueCandidates) {
        if (this._tryLinkOddsInline(textEl, candidate, event, originalMetaBet)) return;
      }
    }
    _tryLinkOddsInline(textEl, oddsStr, event, originalMetaBet) {
      const escaped = oddsStr.replace(/[.]/g, "\\.");
      const pattern = new RegExp("(?<!\\d)".concat(escaped, "(?!\\d)"));
      const walker = document.createTreeWalker(textEl, NodeFilter.SHOW_TEXT, null);
      let firstMatch = null;
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.parentElement && node.parentElement.closest("a")) continue;
        const idx = node.textContent.search(pattern);
        if (idx >= 0) {
          firstMatch = {
            node,
            idx
          };
          break;
        }
      }
      if (!firstMatch) return false;
      const {
        node,
        idx
      } = firstMatch;
      const text = node.textContent;
      const before = text.slice(0, idx);
      const after = text.slice(idx + oddsStr.length);
      const a = document.createElement("a");
      a.href = event.betUrl;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.className = "om-bet-cta-inline";
      a.textContent = oddsStr;
      a.addEventListener("click", e => {
        this._trackCtaClick({
          bookmakerName: event.bookmakerName || "bookmaker",
          betUrl: event.betUrl,
          label: event.label || ""
        }, "inline_odds");
        if (this._isInterceptEnabled() && originalMetaBet) {
          var _originalMetaBet$odds, _originalMetaBet$odds2, _originalMetaBet$odds3, _originalMetaBet$matc, _originalMetaBet$outr, _originalMetaBet$outr2, _originalMetaBet$matc2, _originalMetaBet$matc3, _originalMetaBet$outr3, _originalMetaBet$matc4, _originalMetaBet$book, _originalMetaBet$book2, _originalMetaBet$book3;
          const bet = {
            outcomeId: originalMetaBet.betId,
            matchId: originalMetaBet.matchId,
            selection: originalMetaBet.selection || null,
            marketDescription: originalMetaBet.marketDescription || null,
            oddsDecimal: (_originalMetaBet$odds = (_originalMetaBet$odds2 = originalMetaBet.odds) === null || _originalMetaBet$odds2 === void 0 ? void 0 : _originalMetaBet$odds2.decimal) !== null && _originalMetaBet$odds !== void 0 ? _originalMetaBet$odds : null,
            oddsFractional: ((_originalMetaBet$odds3 = originalMetaBet.odds) === null || _originalMetaBet$odds3 === void 0 ? void 0 : _originalMetaBet$odds3.fractional) || null,
            homeTeam: ((_originalMetaBet$matc = originalMetaBet.match) === null || _originalMetaBet$matc === void 0 ? void 0 : _originalMetaBet$matc.homeTeam) || ((_originalMetaBet$outr = originalMetaBet.outright) === null || _originalMetaBet$outr === void 0 ? void 0 : _originalMetaBet$outr.entityTeam) || ((_originalMetaBet$outr2 = originalMetaBet.outright) === null || _originalMetaBet$outr2 === void 0 ? void 0 : _originalMetaBet$outr2.entityName) || null,
            awayTeam: ((_originalMetaBet$matc2 = originalMetaBet.match) === null || _originalMetaBet$matc2 === void 0 ? void 0 : _originalMetaBet$matc2.awayTeam) || null,
            competition: ((_originalMetaBet$matc3 = originalMetaBet.match) === null || _originalMetaBet$matc3 === void 0 ? void 0 : _originalMetaBet$matc3.competition) || ((_originalMetaBet$outr3 = originalMetaBet.outright) === null || _originalMetaBet$outr3 === void 0 ? void 0 : _originalMetaBet$outr3.competitionName) || null,
            matchDate: ((_originalMetaBet$matc4 = originalMetaBet.match) === null || _originalMetaBet$matc4 === void 0 ? void 0 : _originalMetaBet$matc4.date) || null,
            bookmakerId: (_originalMetaBet$book = (_originalMetaBet$book2 = originalMetaBet.bookmaker) === null || _originalMetaBet$book2 === void 0 ? void 0 : _originalMetaBet$book2.id) !== null && _originalMetaBet$book !== void 0 ? _originalMetaBet$book : null,
            bookmakerName: ((_originalMetaBet$book3 = originalMetaBet.bookmaker) === null || _originalMetaBet$book3 === void 0 ? void 0 : _originalMetaBet$book3.name) || null,
            deeplink: originalMetaBet.deeplink || null
          };
          if (this._dispatchBetIntercept("inline_odds", [bet], event.betUrl)) {
            e.preventDefault();
          }
        }
      });
      const parent = node.parentNode;
      if (before) parent.insertBefore(document.createTextNode(before), node);
      parent.insertBefore(a, node);
      if (after) parent.insertBefore(document.createTextNode(after), node);
      parent.removeChild(node);
      return true;
    }
    _parseCtaLabel(cta) {
      const labelText = cta.label.replace(/^Place Bet:\s*/i, "").trim();
      const parts = labelText.split(/\s+[\u2014\-]\s+/, 2);
      return {
        pick: parts[0] || labelText,
        match: parts[1] || null
      };
    }
    _classifyCtaKind(ctas) {
      const matches = ctas.map(c => (this._parseCtaLabel(c).match || "").trim().toLowerCase()).filter(Boolean);
      return new Set(matches).size <= 1 ? "bet_builder" : "combo";
    }
    _renderBetCtas(botMsg, ctas) {
      const actions = this._getOrCreateActions(botMsg);
      const kind = ctas.length > 1 ? this._classifyCtaKind(ctas) : "single";
      const labels = this._ctaLabels;
      const headerLabel = kind === "bet_builder" ? labels.builder : kind === "combo" ? labels.combo : labels.quick;
      let ctasEl = actions.querySelector(".om-bet-ctas");
      if (!ctasEl) {
        ctasEl = document.createElement("div");
        ctasEl.className = "om-bet-ctas";
        const lbl = document.createElement("span");
        lbl.className = "om-bet-ctas-label";
        lbl.textContent = headerLabel;
        ctasEl.appendChild(lbl);
        actions.insertBefore(ctasEl, actions.firstChild);
      } else {
        const lbl = ctasEl.querySelector(".om-bet-ctas-label");
        if (lbl) lbl.textContent = headerLabel;
      }
      Array.from(ctasEl.querySelectorAll(".om-bet-cta-btn")).forEach(b => b.remove());
      if (ctas.length === 1) {
        ctasEl.appendChild(this._buildSingleCtaBtn(botMsg, ctas[0]));
      } else {
        ctasEl.appendChild(this._buildMultiCtaBtn(botMsg, ctas, kind));
      }
    }
    _buildSingleCtaBtn(botMsg, cta) {
      const {
        pick,
        match
      } = this._parseCtaLabel(cta);
      const labels = this._ctaLabels;
      const a = document.createElement("a");
      a.className = "om-bet-cta-btn";
      a.href = cta.betUrl;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      const main = document.createElement("div");
      main.className = "om-bet-cta-main";
      const kicker = document.createElement("span");
      kicker.className = "om-bet-cta-kicker";
      kicker.textContent = match ? labels.placeBet + " \u00B7 " + match : labels.placeBet;
      const text = document.createElement("span");
      text.className = "om-bet-cta-text";
      text.textContent = pick || labels.placeBetNow;
      main.appendChild(kicker);
      main.appendChild(text);
      const arrow = document.createElement("span");
      arrow.className = "om-bet-cta-arrow";
      arrow.textContent = "\u2192";
      a.appendChild(main);
      a.appendChild(arrow);
      a.addEventListener("click", e => {
        this._trackCtaClick(cta, "message_bet_cta");
        if (this._isInterceptEnabled()) {
          const bets = this._collectBetsFromMessage(botMsg);
          const payload = bets.length === 1 ? bets : bets.slice(0, 1);
          if (this._dispatchBetIntercept("single", payload, cta.betUrl)) {
            e.preventDefault();
          }
        }
      });
      return a;
    }
    _buildMultiCtaBtn(botMsg, ctas, kind) {
      const first = ctas[0];
      const legs = ctas.length;
      const picks = ctas.map(c => this._parseCtaLabel(c).pick).filter(Boolean);
      const labels = this._ctaLabels;
      const kindLabel = kind === "bet_builder" ? labels.builder : labels.combo;
      const a = document.createElement("a");
      a.className = "om-bet-cta-btn";
      a.href = first.betUrl;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      const main = document.createElement("div");
      main.className = "om-bet-cta-main";
      const kicker = document.createElement("span");
      kicker.className = "om-bet-cta-kicker";
      kicker.textContent = kindLabel + " \u00B7 " + labels.legs(legs);
      const text = document.createElement("span");
      text.className = "om-bet-cta-text";
      text.textContent = labels.placeBetNow;
      main.appendChild(kicker);
      main.appendChild(text);
      if (picks.length > 0) {
        const subs = document.createElement("span");
        subs.className = "om-bet-cta-subs";
        subs.textContent = picks.join(" \u00B7 ");
        main.appendChild(subs);
      }
      const arrow = document.createElement("span");
      arrow.className = "om-bet-cta-arrow";
      arrow.textContent = "\u2192";
      a.appendChild(main);
      a.appendChild(arrow);
      a.addEventListener("click", e => {
        this._trackCtaClick(_objectSpread(_objectSpread({}, first), {}, {
          label: kind === "bet_builder" ? "Place Bet Builder (".concat(legs, " legs)") : "Place Combo (".concat(legs, " legs)")
        }), kind === "bet_builder" ? "message_bet_builder_cta" : "message_combo_cta");
        if (this._isInterceptEnabled()) {
          const bets = this._collectBetsFromMessage(botMsg);
          const source = kind === "bet_builder" ? "bet_builder" : "combo";
          if (this._dispatchBetIntercept(source, bets, first.betUrl)) {
            e.preventDefault();
          }
        }
      });
      return a;
    }
    _trackCtaClick(cta, source) {
      const widgetKey = this.getAttribute("widget-key");
      fetch(this._apiBase + "/api/public/conversion", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Widget-Key": widgetKey
        },
        body: JSON.stringify({
          trackingId: "cta_" + Date.now() + "_" + Math.random().toString(36).slice(2, 8),
          conversationId: this._conversationId || null,
          bookmaker: cta.bookmakerName || "svenskaspel",
          actionType: "place_bet_click",
          trackingData: {
            label: cta.label || null,
            url: cta.betUrl,
            source
          },
          timestamp: new Date().toISOString(),
          userAgent: navigator.userAgent,
          referrer: document.referrer || null
        })
      }).catch(() => {});
    }

    _formatMarkdown(text) {
      const lines = text.split("\n");
      let html = "";
      let i = 0;
      let inList = false;
      let listType = "";
      while (i < lines.length) {
        const line = lines[i];

        if (line.trim().match(/^\|(.+)\|$/)) {
          const tableLines = [];
          while (i < lines.length && lines[i].trim().match(/^\|(.+)\|$/)) {
            tableLines.push(lines[i].trim());
            i++;
          }
          html += this._renderTable(tableLines);
          continue;
        }

        if (inList && !line.match(/^\s*[-*]\s/) && !line.match(/^\s*\d+\.\s/)) {
          html += listType === "ul" ? "</ul>" : "</ol>";
          inList = false;
        }

        const headerMatch = line.match(/^(#{1,4})\s+(.+)$/);
        if (headerMatch) {
          const level = headerMatch[1].length;
          html += "<h" + level + ">" + this._inlineFormat(headerMatch[2]) + "</h" + level + ">";
          i++;
          continue;
        }

        if (line.trim().match(/^[-*_]{3,}$/)) {
          html += "<hr>";
          i++;
          continue;
        }

        const ulMatch = line.match(/^\s*[-*]\s+(.+)$/);
        if (ulMatch) {
          if (!inList || listType !== "ul") {
            if (inList) html += listType === "ul" ? "</ul>" : "</ol>";
            html += "<ul>";
            inList = true;
            listType = "ul";
          }
          html += "<li>" + this._inlineFormat(ulMatch[1]) + "</li>";
          i++;
          continue;
        }

        const olMatch = line.match(/^\s*\d+\.\s+(.+)$/);
        if (olMatch) {
          if (!inList || listType !== "ol") {
            if (inList) html += listType === "ul" ? "</ul>" : "</ol>";
            html += "<ol>";
            inList = true;
            listType = "ol";
          }
          html += "<li>" + this._inlineFormat(olMatch[1]) + "</li>";
          i++;
          continue;
        }

        if (line.match(/^>\s*/)) {
          html += "<blockquote>" + this._inlineFormat(line.replace(/^>\s*/, "")) + "</blockquote>";
          i++;
          continue;
        }

        if (line.trim() === "") {
          html += "<br>";
          i++;
          continue;
        }

        html += this._inlineFormat(line) + "<br>";
        i++;
      }
      if (inList) html += listType === "ul" ? "</ul>" : "</ol>";
      html = html.replace(/(<br>)+$/, "");
      return html;
    }

    _escapeAttr(str) {
      return String(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }

    _applyBrandImage(attr, imgElOrList, hostClass) {
      if (!imgElOrList) return;
      const imgs = typeof imgElOrList.forEach === "function" ? Array.from(imgElOrList) : [imgElOrList];
      if (!imgs.length) return;
      const raw = this.getAttribute(attr);
      const url = raw ? this._safeUrl(raw) : null;
      imgs.forEach(img => {
        if (url) img.src = url;else img.removeAttribute("src");
      });
      if (url) this.classList.add(hostClass);else this.classList.remove(hostClass);
    }
    _safeUrl(url) {
      try {
        const parsed = new URL(url, window.location.href);
        if (parsed.protocol === "https:") return parsed.href;
        if (parsed.protocol === "http:") {
          parsed.protocol = "https:";
          return parsed.href;
        }
        return null;
      } catch (e) {
        return null;
      }
    }
    _inlineFormat(text) {
      return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\*(.+?)\*/g, "<em>$1</em>").replace(/__(.+?)__/g, "<strong>$1</strong>").replace(/_(.+?)_/g, "<em>$1</em>").replace(/`(.+?)`/g, "<code>$1</code>").replace(/\[(.+?)\]\((.+?)\)/g, (match, label, rawUrl) => {
        const safeHref = this._safeUrl(rawUrl);
        if (!safeHref) return label; 
        return '<a href="' + this._escapeAttr(safeHref) + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
      });
    }
    _renderTable(tableLines) {
      if (tableLines.length < 2) return tableLines.join("<br>");
      const parseRow = line => line.replace(/^\|/, "").replace(/\|$/, "").split("|").map(c => c.trim());
      const headers = parseRow(tableLines[0]);
      const isSeparator = tableLines[1].match(/^\|[\s\-:|]+\|$/);
      const dataStart = isSeparator ? 2 : 1;
      let out = "<table><thead><tr>";
      headers.forEach(h => {
        out += "<th>" + this._inlineFormat(h) + "</th>";
      });
      out += "</tr></thead><tbody>";
      for (let r = dataStart; r < tableLines.length; r++) {
        if (tableLines[r].match(/^\|[\s\-:|]+\|$/)) continue;
        const cells = parseRow(tableLines[r]);
        out += "<tr>";
        cells.forEach(c => {
          out += "<td>" + this._inlineFormat(c) + "</td>";
        });
        out += "</tr>";
      }
      out += "</tbody></table>";
      return out;
    }
  }
  customElements.define("oddsmind-chat", OddsMindChat);
})();

 })(window);